export default {
    salesforceNavigation: {
        openContractAssets: "Åpne Assets for eierkontrakten i Salesforce",
        assetsLabel: "SF Assets",
        openAccount: "Åpne konto i Salesforce",
        openContract: "Åpne kontrakt i Salesforce",
        loading: "Henter Salesforce-lenke",
        popupBlocked: "Nettleseren blokkerte fanen. Tillat popup-vinduer og prøv igjen.",
        NotLinked: "Ingen tilsvarende post funnet i Salesforce",
        Ambiguous: "Flere Salesforce-poster samsvarer; lenken er ikke tilgjengelig",
        Unavailable: "Salesforce-lenken er ikke tilgjengelig",
    },
    supportOrders: {
        executionFailed: "Kjøring feilet",
        awaitingManualExecution: "Venter på manuell kjøring",
        awaitingExecution: "Venter på kjøring",
        waitingForAgreement: "Venter på brukerstøtteavtale",
        followUpTitle: "Salesforce-ordre som krever oppfølging",
    },
    licenseUsageSummary: {
        daysUsed: "Dager brukt",
        userDays: "Brukerdager",
        failures: "Avvisninger",
        userDetails: "Brukerdetaljer",
        productsTab: "Produkter",
        graphTab: "Graf",
        productsTitle: "Lisensbruk per produkt",
        productDetails: "Produktdetaljer",
        productUsageInfo: "Produkttotalene bruker de inkluderte online-lisensene. Unike brukere telles én gang; brukerdager summeres fortsatt per bruker og lisens. Avvisninger uten entydig lisens inngår uavhengig av valget for inaktive lisenser. Maksimalt samtidig belegg og registrert kapasitetsintervall vises direkte når nøyaktig én lisens er inkludert.",
        seeLicenseDetails: "Se lisensdetaljer",
        multipleLicensePeaksInfo: "Noen produkter har flere inkluderte lisenser. Maksimalt samtidig belegg og registrert kapasitetsintervall kan ikke kombineres sikkert. Utvid produktet for å se verdiene per lisens.",
        productUnassignedFailuresInfo: "Disse avvisningene inngår i produkttotalen, men kan ikke knyttes entydig til en lisens.",
        noProductLicenses: "Ingen lisenser er inkludert for dette produktet med gjeldende filtre.",
        noUnassignedProductFailures: "Ingen avvisninger uten entydig lisens er registrert for dette produktet i perioden.",
        usageTab: "Bruk",
        rejectionsTab: "Avvisninger ({{count}})",
        noLicenseTab: "Ingen lisens tilgjengelig ({{count}})",
        userUnassignedFailuresInfo: "Disse avvisningene inngår i brukerens total, men kan ikke knyttes entydig til en lisens. Grupperes per produkt.",
        noUnassignedUserFailures: "Ingen avvisninger uten entydig lisens er registrert for denne brukeren i perioden.",
        noUserLicenses: "Ingen lisensbruk eller avvisninger knyttet til en lisens vises for denne brukeren med gjeldende filtre.",
        allSeatsOccupied: "Avvisninger: alle seter opptatt",
        noLicenseAvailable: "Avvisninger: ingen lisens tilgjengelig",
        productCode: "Produktkode",
        attribution: "Lisensplassering",
        NoMatchingLicense: "Lisensen finnes ikke i valgt lisensoversikt",
        NoLicenseReference: "Ingen lisensreferanse registrert",
        AmbiguousLicense: "Flere lisenser samsvarer med registrert lisensnummer og produktkode",
        ProductMismatch: "Manglende eller motstridende produktkode",
        unassignedFailures: "Avvisninger uten entydig lisens",
        unassignedFailuresInfo: "Avvisningene grupperes per produkt. Utvid et produkt for å se registrerte brukere og kunder. Antall avvisninger inngår på brukerradene, men knyttes aldri til en lisens eller telles som bruk. Disse hendelsene påvirkes ikke av valget for inaktive lisenser.",
        daysAndFailuresInfo: "En brukerdag er én bruker som bruker én lisens på én registrert UTC-dato. Flere økter samme dag teller én gang; lisens- og brukertotaler summerer dager per bruker og lisens. Kun alle-seter-opptatt og ingen-lisens-tilgjengelig telles som avvisninger. Brukere med bare avvisninger har null bruk. Tallene viser registrert historikk, ikke en avstemming mot Autodesk-fakturering.",
        title: "Lisensbruk",
        usersTitle: "Lisensbruk per bruker",
        perspective: "Rapportvisning",
        reportInfo: "Om rapporten",
        reportInfoWithWarnings: "Om rapporten: ufullstendige bruksdata",
        licensesTab: "Lisenser",
        usersTab: "Brukere",
        licensesUsed: "Lisenser brukt",
        userHours: "Brukerens timer i bruk",
        noRecordedUsers: "Ingen brukeraktivitet er registrert for lisensene som inngår i valgte filtre og periode.",
        currentSeats: "Seter i dag",
        recordedSeats: "Registrerte seter",
        unknown: "Ukjent",
        showInactive: "Vis inaktive lisenser",
        terminationDate: "Oppsigelsesdato",
        peakOccupiedSeats: "Maks samtidige brukere",
        uniqueUsers: "Unike brukere",
        hours: "Timer i bruk",
        empty: "Ingen lisenser med lisensiering ble funnet for valgte filtre.",
        noUsers: "Ingen brukeraktivitet er registrert for denne lisensen i perioden.",
        historicalModuleUsageInfo: "Når en modul mangler egen starttid, brukes hovedsesjonens start som et estimat. Dette kan overvurdere timer i bruk, maks samtidige brukere og brukerdager. Historiske moduldata kan også bygge på hele hovedsesjonen i stedet for modulens faktiske brukstid. Estimert bruk telles som bruk, ikke som utelatte setedøgn.",
        excludedSeatDays: "Utelatte setedøgn",
        incompleteSeatCoverage: "Ufullstendige bruksdata for lisensene {{licenses}}: Seter uten gyldig starttid er utelatt. Timer, setetopper og brukertall kan være for lave, og null betyr ikke nødvendigvis ingen bruk. Utelatte setedøgn teller hvert berørte sete én gang per dag.",
    },
    app: {
        customers: "Kunder",
        customerDetails: "Kundedetaljer",
        contracts: "Kontrakter",
        userSupport: "Brukerstøtte",
        productList: "Produktliste",
        licenses: "Lisenser",
        activeUsers: "Aktive brukere",
        loginFailed: "Mislykket pålogging",
        rejectedLogin: "Avvist pålogging",
        licenseExploitation: "Lisensutnyttelse",
        personActivity: "Personaktivitet",
        expiredLicenses: "Utløpte lisenser",
        offlineLicenses: "Offline lisenser",
        system: "System",
        licenseChanges: "Lisensendringer",
        webUpdates: "Web oppdateringer",
        reports: "Rapporter",
        newSales: "Nye salg",
        renewals: "Fornyelser",
        churn: "Churn",
        graphs: "Grafer",
        licenseUsage: "Lisensbruk",
        sale: "Salg",
        other: "Annet",
        productStructure: "Produktstruktur",
        productVersion: "Produktversjon",
        course: "Kurs",
        checkFocusAccount: "Sjekk Focuskonto",
        emails: "Eposter",
        offers: "Tilbud",
        kuaAdmin: "Kua Admin",
        company: "Firma",
        futureRenewals: "Fremtidige fornyelser",
        requests: "Forespørsler",
        myPageStatus: "Min Side status",
        secretPages: "Hemmelige sider",
        courseAdmin: "Kurs Admin",
        courseCatalog: "Kurskatalog",
        courseList: "Kursliste",
        courseEvaluation: "Kursevaluering",
        resources: "Resurser",
        informationTexts: "Informasjonstekster",
        emailTemplates: "Epostmaler",
        users: "Brukere",
        autodeskOpportunities: "Opportunities",
        licenseAccess: "Lisenstilgang",
        failedOrders: "SF Mislykkede ordre",
        assetSync: "SF Lisens synk",
        accountReconciliation: "SF-sammenligning",
    },
    salesForceAccountReconciliation: {
        sync: {
            column: "Handling", button: "Sync SF → WK", warningButton: "Sync SF → WK (advarsel)",
            savedButton: "Ordre registrert", title: "Sync konto {{number}} fra SF til WK",
            tooltip: "Vil synce fra SF til WK: {{fields}}.",
            blockedLink: "Kan ikke synces: kundekoblingen er ufullstendig.",
            description: "SF er kilde for de sammenlignede feltene, også tomme verdier. Besøkssted brukes for WK Place, BillingCity for poststed. Payer code og adresseekstra beholdes.",
            billingCityWarning: "Kontroller besøksstedet i SF før sync: BillingCity ({{city}}) stemmer med WK, men besøksstedet avviker eller er tomt. Sync bruker besøksstedet, ikke BillingCity.",
            clearWarning: "Advarsel: Manglende SF-verdier vil fjerne eksisterende WK-verdier i disse feltene.",
            blocked: "Sync krever en entydig kunde i begge systemer og kjente felt/landkoder.",
            preview: "Ferske feltavvik før sync", loading: "Kontrollerer eller sender ordre …",
            confirm: "Bekreft og send ordre", close: "Lukk", newPreview: "Hent ny forhåndsvisning",
            retry: "Kontroller samme innsending", refresh: "Kontroller rapport på nytt",
            submitted: "Ordren er sendt. Dette bekrefter ikke at synkroniseringen er ferdig. Kontroller ordrestatus og hent rapporten på nytt etter utføring.",
            recorded: "Denne ordren er allerede lagret og er ikke sendt på nytt. Kontroller ordrestatus; utføring er ikke bekreftet her.",
            orderId: "Ordre-ID: {{id}}",
            errors: {
                InvalidPreview: "Bekreftelsen er utløpt eller ugyldig. Hent en ny forhåndsvisning.",
                SourceChanged: "SF- eller WK-data er endret siden forhåndsvisningen. Kontroller nye verdier før sync.",
                AmbiguousLink: "Kundekoblingen er ikke lenger entydig. Kontroller kundenummer, kilde-ID-er og duplikater.",
                NoLongerEligible: "SF-kontoen har ikke lenger noen kontrakt. Sync er blokkert.",
                NoDifferences: "Ingen avvik å synce nå. Hent rapporten på nytt.",
                SellerUnresolved: "Selgers e-post fra SF kan ikke kobles entydig til en WK-bruker. Sync er blokkert.",
                UnknownCountry: "Landkoden fra SF gjenkjennes ikke. Sync er blokkert.",
                OperatorUnresolved: "Den innloggede brukeren kan ikke kobles entydig til en WK-bruker.",
                PendingOrder: "Det finnes allerede en åpen Account-oppdateringsordre. Kontroller den før ny sync.",
                OrderConflict: "En eksisterende ordre kunne ikke knyttes sikkert til denne handlingen. Kontroller ordren.",
                DispatchFailed: "Ordren er lagret, men sending til orkestratoren er ikke bekreftet. Kontroller ordren før du forsøker en ny sync.",
                IncompleteSource: "SF-svaret mangler valgte felt. Sync er blokkert for å unngå utilsiktet sletting.",
                RequestFailed: "Forespørselen kunne ikke bekreftes. Ved innsending kan ordren allerede være lagret. Kontroller samme innsending eller ordrestatus før ny sync."
            }
        },
        contractScope: "SF-kontoer uten kontrakter er ikke sammenlignet. Utelatt fra hentet utvalg: {{excluded}}. Alle kontraktstatuser teller.",
        contractScopeCountUnavailable: "Kontraktfilter er brukt, men antall utelatte SF-kontoer mangler eller er ugyldig. Hent rapporten på nytt.",
        salesforceAccount: "SF-kunde", webkuaAccount: "WK-kunde",
        salesforceName: "SF-kundenavn", webkuaName: "WK-kundenavn",
        mainFinding: "Hovedfunn", allFindings: "Alle funn", differences: "Feltavvik (råverdier)",
        canSyncFilter: "Kan synces ({{count}})",
        differencesTitle: "Hva er forskjellig", nextCheck: "Hva bør kontrolleres",
        moreFindings_one: "1 annet funn", moreFindings_other: "{{count}} andre funn",
        notFound: "Ikke funnet", notCompared: "Ikke sammenlignet",
        notReported: "Ikke oppgitt", emptyValue: "Tom verdi",
        sourceLimitations: "Rapporten inneholder kundenavn og avvikende felt, ikke komplette kundedokumenter. Like felt vises ikke.",
        missingSalesforceKey: "SF-kunden mangler WebKUA-kundenummer. Koblingen kan ikke kontrolleres.",
        missingWebkuaKey: "WK-kunden mangler kundenummer. Koblingen kan ikke kontrolleres.",
        notFoundInWebkua: "SF-kunden er ikke funnet i WK.",
        notFoundInSalesforce: "WK-kunden er ikke funnet i SF.",
        ambiguousCustomer: "Kundenummeret finnes på flere kunder. Koblingen er ikke entydig.",
        unknownComparisonField: "Ukjent sammenligningsfelt.",
        fieldMismatch: "{{field}} er forskjellig.", missingField: "{{field}} er ikke oppgitt i {{system}}.",
        unrecognizedCountry: "Landkoden fra SF gjenkjennes ikke.",
        unknownField: "Ukjent sammenligningsfelt: {{field}}",
        noFindingDetails: "Ingen konkrete feltavvik oppgitt. Kontroller kildegrunnlaget.",
        filteredRows: "Viser {{shown}} av {{total}} rader.", clearFilters: "Nullstill funnfiltre",
        filters: { linkage: "Kundekobling", fields: "Feltavvik", identity: "Kundeidentitet",
            contact: "Selgerkontakt", address: "Adresse", unresolved: "Uavklart grunnlag" },
        fields: { companyName: "Kundenavn", organizationNumber: "Organisasjonsnummer",
            sellerEmail: "Selgers e-post", csn: "Autodesk-kundenummer (CSN)", visitingCity: "Besøkssted (SF / WK Place)",
            postalAddress: "Postadresse", postalCity: "Poststed", postalCode: "Postnummer",
            country: "Land (SF-kode / WK-land-ID)", countryUnrecognized: "Landkode (gjenkjennes ikke i SF)" },
        checks: {
            linkage: "Kontroller kundenummer og eventuelle duplikater før kunder kobles eller feltverdier rettes.",
            identity: "Kontroller kundens navn og organisasjonsnummer mot registrerte kundeopplysninger.",
            csn: "Kontroller Autodesk-kundenummeret på begge sider mot riktig kundekonto.",
            contact: "Kontroller e-posten til Account-eieren i SF mot selgerkontakten i WK.",
            visitingCity: "Kontroller SF besøkssted (VisitingAddress__City__s) mot WK Place. BillingCity brukes bare for poststed.",
            address: "Kontroller kundens postadresse på begge sider.",
            country: "SF bruker ISO-landkode, WK bruker numerisk land-ID. Kontroller at kodene angir riktig land, ikke at råverdiene er like.",
            unknownField: "Feltet er ikke kartlagt i denne visningen. Kontroller råverdiene og feltkoblingen før retting.",
        },
        accounts: "Kontoer",
        assets: "Assets",
        contracts: "Kontrakter",
        contractLoadError: "Kunne ikke hente kontraktsammenligningen.",
        fetch: "Hent valgte sammenligninger",
        results: "Sammenligningsresultater",
        assetLoadError: "Kunne ikke hente Asset-sammenligningen. Ingen fullstendig resultatliste er tilgjengelig.",
        loading: "Henter sammenligning",
        loadError: "Kunne ikke hente kontosammenligningen. Ingen fullstendig resultatliste er tilgjengelig.",
        incomplete: "Sammenligningen er ufullstendig. Listen viser ikke nødvendigvis alle avvik.",
        deferredAccountFields: "StarterMap-betalerkode, ekstra adressefelt og kontofelt som bare settes ved opprettelse er ennå ikke sammenlignet.",
        noDifferences: "Ingen avvik funnet.",
        salesforceId: "Salesforce ID",
        webkuaId: "WebKUA ID",
        status: "Status",
        field: "Felt",
        salesforceValue: "Salesforce-verdi",
        webkuaValue: "WebKUA-verdi",
        UnmatchedSalesforce: "Mangler WebKUA-kundenummer i Salesforce",
        MissingInWebkua: "Mangler i WebKUA",
        MissingInSalesforce: "Mangler i Salesforce",
        DuplicateCompanyNumber: "Duplikat kundenummer - usikker kobling",
        FieldMismatch: "Ulike feltverdier",
    },
    salesForceContractReconciliation: {
        sync: {
            column: "Handling", button: "Sync SF → WK", savedButton: "Ordre registrert",
            title: "Sync kontrakt {{number}} fra SF til WK",
            tooltip: "Vil synce fra SF til WK: {{fields}}.",
            unsupportedFields: "Kan ikke synces: {{fields}} støttes ikke.",
            emptyFields: "Kan ikke synces: {{fields}} mangler i SF og kan ikke tømmes i WK.",
            inactiveSource: "Kan ikke synces: kontrakten er ikke aktiv i {{system}}.",
            todayEndDate: "Kan ikke synces: stoppdato er i dag og ville endre aktivitet i WK.",
            linkNumber: "Kan ikke synces: kontraktnummerkoblingen mangler eller er ulik.",
            customerLink: "Kan ikke synces: kundekoblingen mangler eller kundene er ulike.",
            sourceLink: "Kan ikke synces: koblingen til en kilde mangler.",
            unsupportedKind: "Kan ikke synces: {{kind}}.",
            description: "Handlingen sender eksisterende kontraktoppdateringsordre med de viste SF-verdiene. Andre felt beholdes. Kontrakten kontrolleres før innsending, men ordren kan opprette en kontrakt hvis WK-koblingen forsvinner før utføring.",
            preview: "Ferske feltavvik før sync", loading: "Kontrollerer eller sender ordre …",
            confirm: "Bekreft og send ordre", close: "Lukk", newPreview: "Hent ny forhåndsvisning",
            retry: "Kontroller samme innsending", refresh: "Kontroller rapport på nytt",
            submitted: "Ordren er sendt. Synkroniseringen er ikke bekreftet ferdig. Kontroller ordrestatus og hent rapporten på nytt etter utføring.",
            recorded: "Ordren er allerede lagret og er ikke sendt på nytt. Kontroller ordrestatus; utføring er ikke bekreftet her.",
            orderId: "Ordre-ID: {{id}}",
            errors: {
                InvalidPreview: "Bekreftelsen er utløpt eller ugyldig. Hent en ny forhåndsvisning.",
                SourceChanged: "SF- eller WK-data er endret siden forhåndsvisningen. Hent en ny forhåndsvisning.",
                AmbiguousLink: "Sync krever én kontrakt i hvert system, samme kunde og entydige kontraktnumre og kilde-ID-er.",
                NoDifferences: "Ingen feltavvik som kan rettes med denne handlingen. Dato-/statusadvarsler alene kan ikke synces.",
                UnsupportedDifference: "Eksisterende ordre kan ikke rette alle avvik. Startdato, fakturaintervall, fakturakunde og aktivitetsendringer støttes ikke. Stoppdato i dag kan heller ikke synces uten å endre aktivitet.",
                UnsafeSource: "Kildegrunnlaget er mangelfullt, eller SF-status og datoer er inkonsistente. Kontroller detaljene før sync.",
                EmptySource: "Ordren kan ikke tømme WK-felt. Manglende SF-verdier gjør derfor at denne raden ikke kan synces.",
                OperatorUnresolved: "Den innloggede brukeren kan ikke kobles entydig til en WK-bruker.",
                PendingOrder: "Det finnes allerede en åpen kontraktoppdateringsordre. Kontroller den før ny sync.",
                OrderConflict: "En eksisterende ordre kunne ikke knyttes sikkert til handlingen. Kontroller ordren.",
                DispatchFailed: "Ordren er lagret, men sending er ikke bekreftet. Kontroller ordren før ny sync.",
                RequestFailed: "Forespørselen kunne ikke bekreftes. Ordren kan allerede være lagret. Kontroller samme innsending eller ordrestatus før ny sync."
            }
        },
        sourcePresence: "Funnet i", mainFinding: "Hovedfunn", allFindings: "Alle funn",
        comparisonKind: "Avvikstype", sfLinkKey: "SF-koblingsnummer lagret i WK",
        presence: { both: "SF og WK", salesforceOnly: "Bare SF", webkuaOnly: "Bare WK", neither: "Ingen kilder" },
        multipleMatches: "Flere mulige treff", sourceEvidence: "Vis kildeinformasjon",
        nextCheck: "Hva bør kontrolleres", moreFindings_one: "1 annet funn", moreFindings_other: "{{count}} andre funn",
        notFound: "Ikke funnet", notCompared: "Ikke sammenlignet", notReported: "Ikke oppgitt",
        noTerminationDate: "Ingen opphørsdato", unknown: "Uavklart",
        noFindingDetails: "Ingen konkret årsak oppgitt. Kontroller kildeinformasjonen.",
        missingLinkKey: "SF-kontraktnummer mangler. Koblingen kan ikke kontrolleres.",
        notFoundInSalesforce: "WK-kontrakten er ikke funnet i SF med dette koblingsnummeret.",
        notFoundInWebkua: "SF-kontrakten er ikke funnet i WK med dette kontraktnummeret.",
        ambiguousSources: "Flere mulige kontrakttreff: {{sf}} i SF og {{wk}} i WK.",
        sourceIssue: "{{system}}: {{issue}}", unattributedIssue: "Kildeside ikke oppgitt: {{issue}}",
        activityFinding: "SF: {{sf}} · WK: {{wk}}", customerFinding: "Ulik kunde: SF {{sf}} · WK {{wk}}",
        fieldFinding: "{{field}} er forskjellig.",
        laggingWebkua_one: "WK ligger ett fakturaintervall etter SF.",
        laggingWebkua_other: "WK ligger {{count}} fakturaintervaller etter SF.",
        laggingSalesforce_one: "SF ligger ett fakturaintervall etter WK.",
        laggingSalesforce_other: "SF ligger {{count}} fakturaintervaller etter WK.",
        filteredRows: "Viser {{shown}} av {{total}} rader.", clearFilters: "Nullstill funnfiltre",
        filters: { linkage: "Kontraktkobling", activity: "Aktivstatus", renewal: "Fornyelse",
            fields: "Andre kontraktfelt", unresolved: "Uavklart grunnlag", warningsOnly: "Kun varsler" },
        findingRules: "Funnet i viser hvilke kilder som faktisk er hentet. Et SF-koblingsnummer lagret i WK beviser ikke at SF-kontrakten finnes. Manglende koblingsnummer betyr at den andre siden ikke er sammenlignet. Funn kan overlappe; flere valgte funnfiltre krever at raden oppfyller alle. Neste sjekk er veiledning, ikke en avgjørelse om hvilken side som er riktig. SF-utvalget omfatter Accounts med WebKUA-kundenummer.",
        checks: {
            customerLink: "Kontroller SF-kontraktnummer, kunde og koblingen til WK før feltverdier rettes.",
            activity: "Kontroller SF-status og EndDate mot opphørsdato og vedlikeholdsstopp i WK.",
            renewal: "Kontroller fornyelseshistorikken og fakturaintervallet på begge sider før datoene rettes.",
            dates: "Kontroller datoene mot den avtalte kontraktsperioden før retting.",
            billing: "Kontroller fakturakunde og fakturainformasjon i SF og WK.",
            interval: "Kontroller fakturaintervallet mot avtalen.",
            contact: "Kontroller Bill-to Contact i SF og kontraktansvarlig i WK.",
            sourceData: "Avklar manglende eller ugyldige opplysninger i den angitte kilden før retting.",
        },
        contract: "Kontrakt", company: "Kunde", sfContract: "SF-kontrakt", wkContract: "WK-kontrakt",
        status: "Avvik", changedFields: "Ulike felt", field: "Felt", sfValue: "SF-verdi", wkValue: "WK-verdi",
        issuesTitle: "Uavklart grunnlag", differences: "Feltforskjeller", noSource: "Ingen koblet kontrakt.",
        current: "Aktiv", ended: "Inaktiv",
        counts: "{{inSync}} av {{compared}} sikkert sammenlignede kontrakter er i synk.",
        noDifferences: "Ingen kontraktavvik funnet innenfor sammenligningens omfang.",
        about: "Om kontraktsammenligningen",
        scope: "Kontrakter som er gjeldende på minst én side, har uavklart aktivitet eller inkonsistent SF-status vises. Andre avsluttede kontrakter utelates. Eksakte SF-kontraktnumre brukes til kobling, også når kundene er ulike.",
        dateRules: "Kun SF-status Activated kan være aktiv; øvrige utfylte statuser er inaktive, og manglende status er uavklart. Datoer sammenlignes uten klokkeslett. SF EndDate er siste gyldige dag. WK følger opphørsdato og vedlikeholdsstopp; en forskjell i aktivitet på opphørsdagen kan derfor være forventet.",
        renewalRules: "SF NextRenewDate__c sammenlignes med WK NextInvoicingDate. For et entydig, aktivt kontraktpar på samme kunde med likt, gyldig fakturaintervall markeres den tidligere datoen som ikke fornyet når datogapet er et eksakt helt antall fakturaintervaller i kalendermåneder. Andre gap er ulike fornyelsesdatoer. Dette er en vurdering fra datoene, ikke bekreftelse på utført eller feilet fornyelse. Alle datoer før sammenligningsdagen (UTC) får et varselikon, uavhengig av aktivstatus. Ikonet viser bare at datoen er passert. Aktive kontrakter med like, passerte datoer vises også som varselrader.",
        notRenewedInWebkua: "Ikke fornyet i WK", notRenewedInSalesforce: "Ikke fornyet i SF",
        renewalAssessment: "Fornyelsesvurdering", differentRenewalDates: "Ulike fornyelsesdatoer",
        matchingRenewalDates: "Like fornyelsesdatoer", renewalUnresolved: "Fornyelsesdatoer kan ikke sammenlignes sikkert",
        billingMappings: "Kontraktansvarlig sammenlignes mot Bill_to_Contact__r.Email. Fakturakunden sammenlignes mot BillToAccount__r.WebKuaCustomerNumber__c. I WK brukes fakturakundens kundenummer, eller kontraktkunden hvis fakturakundenummeret er tomt. Manglende fakturainfo er uavklart. Selger avstemmes ikke.",
        warningsTitle: "Varsler",
        warnings: { ExpiredWithoutEndDate: "SF-status er Expired, men EndDate mangler.",
            ExpiredWithCurrentEndDate: "SF-status er Expired, men EndDate er i dag eller frem i tid.",
            ActivatedWithPastEndDate: "SF-status er Activated, men EndDate er passert.",
            SalesforceRenewalDatePassed: "Fornyelsesdato passert i SF",
            WebkuaRenewalDatePassed: "Fornyelsesdato passert i WK" },
        orderLimitations: "Sync krever forhåndsvisning og bekreftelse og tilbys bare når eksisterende ordre kan rette alle feltavvik. Ordren støtter ikke startdato, fakturaintervall, fakturakunde, aktivitetsendringer eller tømming av felt på eksisterende kontrakter.",
        kinds: { MissingKey: "Mangler SF-kontraktnummer", AmbiguousContract: "Flere kontrakter med samme SF-nummer",
            MissingInSalesforce: "Kontrakt bare i WK", MissingInWebkua: "Kontrakt bare i SF",
            ComparisonBlocked: "Uavklart kontraktgrunnlag", CompanyMismatch: "Ulik kunde", ActivityMismatch: "Ulik aktivstatus",
            FieldMismatch: "Ulike kontraktfelt", SourceWarning: "Inkonsistent SF-status", RenewalWarning: "Passert fornyelsesdato" },
        fields: { companyNumber: "Kundenummer", isCurrent: "Aktivstatus", startDate: "Startdato",
            nextRenewalDate: "Neste fornyelse", terminationDate: "Opphørsdato", maintenanceStopDate: "Vedlikeholdsstopp",
            currency: "Valuta", invoiceInterval: "Fakturaintervall (måneder)", invoicedCompanyNumber: "Fakturakundens kundenummer",
            contractResponsibleEmail: "Kontraktansvarlig (e-post)", status: "SF-status" },
        issues: { MissingContractNumber: "SF-kontraktnummer mangler.", MissingCompanyNumber: "Kundenummer mangler.",
            MissingContractInfo: "WK-kontraktinformasjon mangler.", UnknownActivity: "Kontraktaktivitet er uavklart.",
            MissingStartDate: "Startdato mangler.", MissingNextRenewalDate: "Neste fornyelsesdato mangler.",
            InvalidInvoiceInterval: "Fakturaintervall mangler eller er ugyldig.", MissingCurrency: "Valuta mangler.",
            MissingInvoiceInfo: "WK-fakturainfo mangler.", MissingInvoicedCompanyNumber: "Fakturakundens kundenummer mangler." },
    },
    reconciliationFilters: {
        syncFilter: "Synkronisering", categoryFilter: "Kontroll", all: "Alle", canSync: "Kan synkroniseres",
    },
    salesforceInternal: {
        tab: "SF intern",
        requiresAll: "Hent kontoer, assets og kontrakter. Alle tre må være ferdig lastet før SF intern kan brukes.",
        missingEvidence: "SF-kildedata mangler i svaret. Oppdater API-et og hent alle tre sammenligningene på nytt.",
        scope: "Skrivebeskyttet kontroll av SF-data for WK-tilknyttede kunder i dagens NO-sammenligning. Interne/testkunder og tilbudsprodukter er utelatt. Kontraktene gjelder abonnement og kansellering er umiddelbar. Aktive kontrakter må ha aktive, løpende assets med samme sluttdato. Support og engangskjøp er unntatt fra livsløpskontroller. SF og WK kan være enige selv om SF har feil. Avvik mot kontraktens fornyelsesdato er varsler; ulike sluttdatoer mellom aktive assets er feil.",
        snapshots: "Assets hentet: {{assets}}. Kontrakter hentet: {{contracts}}. Dataene hentes separat; nye SF-endringer mellom hentinger kan gi midlertidige avvik. Vurderingsdato følger kontrakthentingen.",
        noFindings: "Ingen funn for de implementerte kontrollene i de hentede dataene. Dette er ikke en full validering av Salesforce.",
        severityFilter: "Alvorlighet", ruleFilter: "Kontroll", all: "Alle",
        severity: { error: "Feil", warning: "Advarsel", unevaluable: "Kan ikke vurderes" },
        sameEndDate: "Samme sluttdato for aktive assets",
        columns: { severity: "Alvorlighet", rule: "Funn", company: "Kundenummer", contractNumber: "SF-kontrakt",
            asset: "Asset", productCode: "Produktkode", assetStatus: "Asset-status", contractStatus: "Kontraktstatus",
            usageEnd: "Asset sluttdato", contractEnd: "Kontrakt sluttdato", renewal: "Neste fornyelse",
            quantity: "Asset-antall", cancellation: "Kanselleringsdato",
            installDate: "Asset installasjonsdato", contractStart: "Kontrakt startdato",
            actual: "Faktisk verdi", expected: "Referanse / forventet verdi" },
        rules: {
            IncompleteAssetEvidence: "Valgte SF-felt mangler i asset-svaret",
            UnknownAssetStatus: "Asset-status kan ikke tolkes", UnknownRecurrence: "Produktets gjentakelse er uavklart",
            MissingContract: "Aktiv løpende asset mangler kontrakt", ContractNotFetched: "Assetens kontrakt finnes ikke i hentet omfang",
            AmbiguousContract: "Flere hentede kontrakter har samme SF-ID", MissingAccount: "Konto-ID mangler på asset eller kontrakt",
            AccountMismatch: "Asset og kontrakt tilhører ulike SF-kontoer", UnknownContractStatus: "Kontraktstatus kan ikke tolkes",
            InvalidDate: "En SF-dato kan ikke tolkes", ActiveOnCancelledContract: "Aktiv asset på kansellert kontrakt",
            ActiveOnExpiredContract: "Aktiv asset på utløpt kontrakt", ActiveOnDraftContract: "Aktiv asset på kontrakt i utkast",
            ActiveOnPastEndedContract: "Aktiv asset på kontrakt med passert sluttdato",
            UsageBeyondContractEnd: "Assetens sluttdato er etter kontraktens sluttdato",
            MissingUsageEnd: "Aktiv løpende asset mangler sluttdato", PastUsageEnd: "Aktiv asset har passert sluttdato",
            MissingRenewalDate: "Fornyelseskontroll mangler kontraktens neste fornyelsesdato",
            RenewalMisalignment: "Assetens sluttdato avviker fra dagen før neste fornyelse",
            ActiveContractWithoutAssets: "Aktiv abonnementskontrakt har ingen aktive, løpende assets",
            IncompleteContractAssets: "Ufullstendige asset-data hindrer vurdering av kontraktens aktive assets",
            ActiveAfterCancellation: "Asset er aktiv selv om kanselleringsdatoen er nådd",
            InconsistentAssetEndDates: "Aktive assets på samme kontrakt har ulike sluttdatoer",
            ActivatedWithPastEndDate: "Aktivert kontrakt har passert sluttdato",
            ExpiredWithoutEndDate: "Utløpt kontrakt mangler sluttdato",
            ExpiredWithCurrentEndDate: "Utløpt kontrakt har sluttdato i dag eller fremover",
            SalesforceRenewalDatePassed: "Aktiv kontrakt har passert fornyelsesdato",
            InvalidQuantity: "Aktiv lisens-asset har manglende eller ugyldig antall",
            ActiveZeroQuantity: "Aktiv lisens-asset har antall null",
            ContractEndBeforeStart: "Kontraktens sluttdato er før startdato",
            ContractRenewalBeforeStart: "Kontraktens fornyelsesdato er før startdato",
            MissingContractIdentity: "Kontrakt mangler SF-ID",
            IncompleteLifecycleEvidence: "Valgte dato- eller kanselleringsfelt mangler i asset-svaret",
            AssetStartAfterEnd: "Assetens installasjonsdato er etter sluttdato",
            ActiveOnFutureContract: "Aktiv asset på kontrakt med startdato i fremtiden",
            CancellationBeforeAssetStart: "Assetens kanselleringsdato er før installasjonsdato",
            CancelledWithoutCancellationDate: "Kansellert løpende asset mangler kanselleringsdato",
        },
    },
    salesForceMetadata: {
        title: "Salesforce-metadata",
        object: "Objekttype",
        fetch: "Hent metadata",
        loading: "Henter Salesforce-feltmetadata...",
        error: "Kunne ikke hente Salesforce-feltmetadata.",
        loaded: "{{objectName}}: {{count}} felt",
        name: "Feltnavn",
        label: "Visningsnavn",
        type: "Felttype",
        referenceTo: "Refererer til",
        relationshipName: "Relasjonsnavn",
    },
    salesForceAssetReconciliationSync: {
        field: "Felt", salesforceValue: "SF-antall", webkuaValue: "WK-antall", fields: { quantity: "Antall" },
        sync: {
            column: "Handling", button: "Sync SF → WK", warningButton: "Sync SF → WK (advarsel)",
            savedButton: "Ordre registrert", title: "Sync {{number}} fra SF til WK",
            tooltip: "Vil synce fra SF til WK: {{fields}}.",
            description: "Sender en Asset-ordre med antallet i forhåndsvisningen. Bare aktivt antall i WK gir stopp; bare aktivt antall i SF gir opprettelse i WK. Koblingen kontrolleres før innsending, men kan endres før ordren utføres.",
            actions: {
                Update: "Oppdaterer antall på eksisterende varelinje. Rabatt og øvrige felt beholdes.",
                Stop: "Stopper eksisterende varelinje med antall 0. Lisensen stoppes også hvis ingen aktive seter gjenstår.",
                CreateLicense: "Oppretter en ny lisens i WK med antall og rabatt fra SF.",
                CreateItem: "Oppretter en ny varelinje på eksisterende WK-lisens med antall og rabatt fra SF."
            },
            usedWarning: "Advarsel: Lisensen er brukt i 2026, sist {{date}}. Sync stopper varelinjen og kan fjerne tilgang som fortsatt er i bruk.",
            reduceWarning: "Antall reduseres fra {{from}} til {{to}}. Dette gir færre seter, men varelinjen stoppes ikke.",
            stopWarning: "Antall endres fra {{from}} til 0. Varelinjen stoppes. Lisensen stoppes også hvis ingen aktive seter gjenstår.",
            preview: "Ferskt antallsavvik før sync", loading: "Kontrollerer eller sender ordre …",
            confirm: "Bekreft og send ordre", close: "Lukk", newPreview: "Hent ny forhåndsvisning",
            retry: "Kontroller samme innsending", refresh: "Kontroller rapport på nytt",
            submitted: "Ordren er sendt. Utføring er ikke bekreftet. Kontroller ordrestatus og hent rapporten på nytt etter utføring.",
            recorded: "Ordren er allerede lagret og er ikke sendt på nytt. Kontroller ordrestatus.",
            orderId: "Ordre-ID: {{id}}",
            errors: {
                InvalidPreview: "Bekreftelsen er utløpt eller ugyldig. Hent ny forhåndsvisning.",
                SourceChanged: "SF-, WK- eller produktdata er endret. Hent ny forhåndsvisning.",
                AmbiguousLink: "Kan ikke synces: kunde-, kontrakt- eller varelinjekoblingen er ikke entydig.",
                NoDifferences: "Ingen antallsavvik å synce nå. Hent rapporten på nytt.",
                MultipleTargets: "Kan ikke synces: flere lisenser eller varelinjer kan bli valgt. Krever manuell retting.",
                DiscountUnsupported: "Kan ikke synces: rabattavvik eller ulik rabattfordeling kan ikke rettes av denne handlingen.",
                ProductUnresolved: "Kan ikke synces: produktkoblingen mangler eller er ikke entydig.",
                InactiveTarget: "Kan ikke synces: den valgte varelinjen er stoppet, eller det finnes ingen aktiv varelinje å stoppe. Ordren reaktiverer ikke stoppede varelinjer.",
                ParentUnresolved: "Kan ikke synces: modulen mangler én entydig aktiv hovedlisens på samme kontrakt.",
                UnsafeSource: "Kan ikke synces: SF-antall, status eller produktgrunnlag er uavklart.",
                UnsafeTarget: "Kan ikke synces: WK-varelinjene har ugyldig produkt-, rabatt- eller setegrunnlag.",
                InvalidQuantity: "Kan ikke synces: antallet må være et heltall fra 0 til 2147483647.",
                IncompleteSource: "Kan ikke synces: nødvendig kilde- eller målinformasjon mangler. Hent rapporten på nytt.",
                UnsupportedDifference: "Kan ikke synces: avviket kan ikke rettes med en antalls-, stopp- eller opprettelsesordre.",
                OperatorUnresolved: "Den innloggede brukeren kan ikke kobles entydig til en WK-bruker.",
                PendingOrder: "Kan ikke synces: en Asset-ordre for samme kontrakt og vare er allerede åpen.",
                OrderConflict: "En eksisterende ordre kunne ikke knyttes sikkert til handlingen. Kontroller ordren.",
                DispatchFailed: "Ordren er lagret, men sending er ikke bekreftet. Kontroller ordren før ny sync.",
                RequestFailed: "Forespørselen kunne ikke bekreftes. Ordren kan allerede være lagret. Kontroller samme innsending eller ordrestatus før ny sync."
            }
        }
    },
    salesForceAssetReconciliation: {
        contracts: "Kontrakt",
        item: "Vare",
        sfQuantity: "Antall SF",
        wkQuantity: "Antall WK",
        renewal: "Utløp / fornyelse",
        usage: "Bruk (2026)",
        sync: "Synk",
        chooseAssets: "Velg Salesforce Asset",
        assetChoice: "{{number}}. {{name}} – {{status}}, antall {{quantity}}, utløp {{date}}",
        otherContractBadge: "Mulig feil kontrakt",
        afterRenewalBadge: "Etter fornyelse",
        renewalUseUnknown: "Registrert bruk, men fornyelsesdato mangler eller er tvetydig",
        syncPlanned: "Planlagt",
        syncOverdue: "Forfalt, åpen",
        syncSummary: "{{state}}: {{quantity}} / {{date}}",
        pendingUnknown: "Åpen ordre, sammendrag ukjent",
        quickFilters: "Hurtigfiltre",
        clearFilters: "Nullstill filtre",
        showDiscount: "Vis rabatt",
        filteredRows: "Viser {{shown}} av {{total}} rader",
        salesforceUsageEndDates: "Varens sluttdato i Salesforce (UsageEndDate)",
        dateSources: "SF: varens sluttdato (UsageEndDate). WK: kontraktens neste fornyelsesdato.",
        aboutComparison: "Om sammenligningen",
        detailsQuantityMismatch: "Ulikt aktivt antall: SF {{sfQuantity}}, WK {{wkQuantity}}.",
        detailsSfOnly: "{{sfQuantity}} aktive i Salesforce – ingen aktiv WK-varelinje på denne kontrakten.",
        detailsWkOnly: "{{wkQuantity}} aktive i WebKUA – ingen aktiv SF Asset på denne kontrakten.",
        sourceEndDate: "Sluttdato (SF)",
        sourceContractRenewal: "Kontraktfornyelse (WK)",
        noActiveSourceAssets: "Ingen aktiv SF Asset på denne kontrakten.",
        noActiveSourceItems: "Ingen aktiv WK-varelinje på denne kontrakten.",
        candidateEvidenceOnly: "Kandidater, ikke sikkert koblede varelinjer.",
        sourceSummary: "{{sfCount}} SF Assets og {{wkCount}} WK-varelinjer. Viste aktive antall: SF {{sfQuantity}}, WK {{wkQuantity}}.",
        quantityExplanation: "SF summerer Quantity for Active Assets, ikke Renewal Quantity. Inactive og Cancelled Assets inngår ikke i produktavstemmingen. WK kontrolleres selvstendig og summerer varelinjer der både lisens og varelinje er aktive. Uavklarte koblinger er ikke sikkert sammenlignet.",
        discountAllocation: "Rabattfordeling",
        productMatchIssue: "Varekobling",
        productCandidates: "Mulige WK-varer for SF-varekoden",
        productCandidatesExplanation: "Dette er kandidater på samme kunde og kontrakt, ikke sikkert matchede varelinjer. Antall brukes ikke til å velge riktig vare.",
        UnknownProductCode: "SF-varekoden har ingen kjent WK-vare",
        AmbiguousProductCode: "SF-varekoden peker på flere mulige WK-varer",
        identifiedItemMissingCounterpart: "Varen er identifisert på denne kunden og kontrakten. Bare én side har et aktivt motstykke. - angir en manglende kildepost, ikke en uavklart varekobling.",
        noMatchedSourceItems: "Ingen sikkert koblede WK-varelinjer.",
        companyComparisonTitle: "Samme kunde og vare på tvers av kontrakter",
        netDifference: "Samlet antallsforskjell (SF − WK)",
        netDiscountDifferences: "Samlet forskjell per rabatt (SF − WK)",
        discrepanciesOnly: "Kun kontraktavvik vises, ikke firmaets totale antall. Kontrakter i synk bidrar med null forskjell og er utelatt. Sikkert fravær av en vare teller som 0 i forskjellen, men vises fortsatt som -.",
        companyComparison: {
            ContractDistributionMismatch: "Antall og rabatt utlignes – ulik kontraktfordeling",
            QuantityBalancedDiscountMismatch: "Antall utlignes – ulik samlet rabattfordeling",
            QuantityMismatch: "Samlet antall er ulikt",
            DiscountMismatch: "Samlet rabattfordeling er ulik",
            ComparisonBlocked: "Samlet avstemming er uavklart",
        },
        discountPrecision: "Antall sammenlignes per rabatt avrundet til {{decimals}} desimaler. Oppdelte lisenser er OK når fordelingen stemmer. Tom SF-rabatt betyr 0%. Manglende WK-rabatt eller ugyldig rabatt er uavklart.",
        unknownDiscount: "Uavklart rabatt",
        discountGroupSummary: "{{discount}}: SF {{sfQuantity}}, WK {{wkQuantity}}",
        DiscountMismatch: "Samme totale antall, men ulikt antall per rabatt",
        DiscountComparisonBlocked: "Rabattfordelingen kan ikke sammenlignes sikkert: rabatt mangler/er ugyldig eller aktivt antall er negativt",
        sourceDetailsUnavailable: "Detaljgrunnlaget mangler i API-svaret. Bygg og restart API-et, og hent data på nytt.",
        noSourceAssets: "Ingen Salesforce-kilder i denne raden.",
        noSourceItems: "Ingen WebKUA-kilder i denne raden.",
        sourceAsset: "Asset / varekode",
        sourceStatus: "Status",
        sourceQuantity: "Antall",
        sourceActiveQuantity: "Aktivt antall",
        renewalQuantity: "Fornyelsesantall",
        excludedFromRenewal: "Utelatt fra fornyelse",
        cancellation: "Kansellering",
        sourceActive: "Aktiv",
        sourceInactive: "Inaktiv",
        sourceLicense: "Lisens",
        sourceItem: "Varelinje",
        sourceDiscount: "Rabatt (%)",
        sourceDates: "Opphør / utløp",
        sourceMaintenance: "Vedlikehold",
        sourceRenewal: "Fornyelse",
        noUsage2026: "Ingen registrert bruk i 2026",
        usageIsLicenseLevel: "Bruk gjelder lisensen, ikke nødvendigvis denne varen. Bruk etter fornyelse er ikke bevis på manglende fakturering.",
        oneTimeExcluded: "Engangsvare – ikke med i avstemmingen",
        filters: {
            afterRenewal: "Brukt etter fornyelse",
            recent: "Brukt siste 30 dager",
            otherContract: "Mulig feil kontrakt",
            contractDistribution: "Avvik utlignes mellom kontrakter",
            discountMismatch: "Ulik rabattfordeling",
            pending: "Åpen synkordre",
            unresolved: "Uavklart grunnlag",
            sfZeroWkPositive: "SF = 0, WK > 0",
        },
        compactStatus: {
            wkOnlyActive: "Aktivt antall bare i WK",
            sfOnlyActive: "Aktivt antall bare i SF",
            MissingInWebkua: "Aktivt antall bare i SF",
            MissingInSalesforce: "Aktivt antall bare i WK",
            UnknownProductCode: "Ukjent SF-varekode",
            AmbiguousProductCode: "Tvetydig SF-varekode",
            QuantityMismatch: "Ulikt antall",
            DiscountMismatch: "Ulik rabattfordeling",
            DiscountComparisonBlocked: "Uavklart rabattfordeling",
            DuplicateWebkuaLicenses: "Samme antall, flere lisenser",
            ComparisonBlocked: "Uavklart kobling",
            UnmappedWebkuaItem: "Uavklart WK-vare",
            UnmappedProduct: "Ukjent/tvetydig vare",
            MissingKey: "Mangler koblingsnøkkel",
            UnclassifiedAsset: "Ukjent SF-status/antall",
            AmbiguousContract: "Tvetydig kontrakt",
        },
        inSyncGroups: "{{inSync}} av {{compared}} sikkert sammenlignede kunde–kontrakt–vare-grupper er i synk på antall og rabattfordeling.",
        noComparableGroups: "0 av 0 grupper i synk: Ingen kunde–kontrakt–vare-grupper kunne sammenlignes sikkert.",
        pendingOrders: "{{count}} åpne Asset-ordrer venter i WebKUA. De er ikke tatt med i dagens lisensantall.",
        pendingOrderId: "Ordre-ID",
        hasPendingOrders: "Åpen synkordre",
        latestPendingQuantity: "Siste planlagte antall",
        latestPendingActivationDate: "Siste synk skulle skje",
        latestPendingUnresolved: "Siste åpne synkordre kunne ikke bestemmes for følgende kunde/kontrakt/vare. Antall og dato vises ikke for disse:",
        webkuaContractNumber: "WebKUA-kontraktnummer",
        webkuaContractRenewalDates: "Fornyelsesdato i WebKUA",
        pendingQuantity: "Planlagt antall",
        activationDate: "Planlagt aktivering",
        deferredAssetFields: "Aktive antall og rabattfordeling med sikker kobling er sammenlignet. Manglende kontraktkoblinger, ukjent status eller vare, historiske Assets og andre Asset-felt er ikke avstemt.",
        contractNumber: "Salesforce-kontraktnummer",
        productCode: "Salesforce-varekode",
        salesforceDiscount: "Rabatt SF (%)",
        lastUsedDate2026: "Siste registrerte bruksdato i WebKUA (2026)",
        usedAfterRenewalDate: "Brukt etter fornyelsesdato (2026)",
        otherWebkuaContracts: "Aktiv vare på andre WebKUA-kontrakter (mulige treff)",
        otherContractItem: "{{contractNumber}}: {{quantity}} (lisens {{licenseNumbers}})",
        candidateContracts: "Mulige SF-kontrakter (kun kunde/vare)",
        itemId: "Vare-ID",
        salesforceActiveQuantity: "Aktivt antall i Salesforce",
        webkuaActiveQuantity: "Aktivt antall i WebKUA",
        salesforceAssetIds: "Salesforce Asset-ID-er",
        webkuaLicenseNumbers: "WebKUA-lisensnumre",
        duplicateWebkuaLicenseNumbers: "Flere aktive WebKUA-lisenser (informasjon)",
        DuplicateWebkuaLicenses: "Samme antall fordelt på flere aktive WebKUA-lisenser; eldre resultat uten rabattavstemming",
        licenseTerminationDates: "Lisensens opphørsdato (per lisensnr.)",
        maintenanceExpirationDates: "Vedlikeholdets utløpsdato (per lisensnr.)",
        itemTerminationDates: "Varelinjens opphørsdato (per lisensnr.)",
        webkuaContractIds: "WebKUA-kontrakt-ID-er",
        AmbiguousContract: "Flere WebKUA-kontrakter med samme Salesforce-nummer – ingen vare sammenlignet",
        UnmappedProduct: "Ukjent eller tvetydig produkt",
        MissingKey: "Mangler kunde- eller kontraktnummer",
        UnclassifiedAsset: "Ukjent Asset-status eller antall",
        UnmappedWebkuaItem: "WebKUA-vare uten sikker kunde-, kontrakt- eller varekobling",
        MissingInWebkua: "SF har aktivt antall, WK har ingen aktiv varelinje for samme kunde, kontrakt og vare",
        MissingInSalesforce: "WK har aktivt antall, SF har ingen aktiv Asset for samme kunde, kontrakt og vare",
        ComparisonBlocked: "Uavklart kobling: viser bare kjente antall, ikke sammenlignet",
        ActivationMismatch: "Bare én side har aktivt antall",
        QuantityMismatch: "Ulikt aktivt antall",
    },
    salesForceAssetSync: {
        itemId: "Webkua ID",
        licenseCount: "Varer i Webkua",
        orderCount: "Pending ordre",
        oldQuantity: "Antall i Webkua",
        newQuantity: "Nytt antall",
        contractRenewalDate: "kontrakt fornyelsesdato",
        syncing: "Synkronisering registrert",
        manuallyHandled: "Satt som manuelt håndtert",
        setAsManuallyHandled: "Sett som manuelt håndtert",
        sync: "Synkroniser",
    },
    headerBar: {
        yourUserSettings: "Dine brukerinnstillinger",
        yourRoles: "Dine roller: ",
        logOut: "Logg ut"
    },
    mainMenu: {
        licensing: "Lisensiering",
        administration: "Administrasjon",
        troubleshooting: "Feilsøking",
        courseAdministration: "Kurs",
        showHiddenItems: "Vis skjulte",
        navigation: "Navigasjon"
    },
    companyDialog: {
        companyIsCreated: "Firma opprettes.",
        couldNotCreateCompany: "Kunne ikke opprette firma.",
        requestDenied: "Forespørsel avslått.",
        couldNotDeclineRequest: "Kunne ikke avslå forespørsel."
    },
    companyRequest: {
        requests: "Forespørsler",
        userAddedInfo: "Informasjon fra bruker",
        isForeign: "Utendlandsk firma",
        country: "Land",
        status: "Status",
        DoesNotExist: "orgnr Finnes ikke i Superoffice",
        ExistsInCRM: "orgnr finnes i Superoffice",
        ExistsInWebkua: "orgnr finnes i Webkua",
        companiesOutsideBrønnøysund: "Firmaer utenfor Brønnøysund",
        followUpSellerName: "Oppfølgingsselger",
        chooseFollowUpSeller: "Jeg kontakter kunde"
    },
    futureRenewals: {
        futureRenewals: "Fremtidige fornyelser"
    },
    orders: {
        orders: "Ordre"
    },
    autodeskOpportunities: {
        address: "Adresse",
        csn: "CSN",
        companyName: "Firmanavn",
        companyNumber: "Firmanummer",
        contractManagerEmail: "Kontraktsansvarlig epost",
        contractManagerName: "Kontraktsansvarlig navn",
        status: "Status",
        quantity: "Antall",
        costPrice: "Kostpris",
        purPriceEur: "Kjøpspris EUR",
        renewalSkus: "Fornyelses SKUer",
        skuDescriptions: "SKU beskrivelser",
        endDate: "Sluttdato",
        renewalSku: "Fornyelses SKU",
        skuDescription: "SKU beskrivelse",
        hasExistingOrder: "Allerede bestilt",
        createOrder: "Bestill"
    },
    autodeskCatalog: {
        title: "Autodesk-katalog",
        subtitle: "Velg hvilke Autodesk-produkter som skal opprettes i Webkua",
        private: "Privat (Agency)",
        product: "Produkt",
        code: "Kode",
        sellable: "Salgbare",
        status: "Status",
        imported: "Opprettet",
        select: "Velg",
        selected: "Valgt",
        update: "Oppdater",
        updated: "oppdatert",
        createProducts: "Opprett/oppdater produkter",
        term: "Periode",
        orderAction: "Type",
        newSale: "Nysalg",
        renewal: "Fornyelse",
        quantity: "Antall",
        servicePlan: "Serviceplan",
        discountProgram: "Rabattprogram",
        priceAfterDiscounts: "Pris etter rabatt",
        specialPrograms: "Rabattprogrammer",
        description: "Beskrivelse",
        noVariants: "Ingen rabattprogrammer",
        programs: "Program",
        products: "produkter",
        priceMismatches: "Prisavvik",
        renewalOnly: "Kun fornyelse",
        setupId: "Nysalg-ID",
        recurringId: "Fornyelse-ID",
        blocked: "Kan ikke opprettes",
        priceDrift: "Prisendring",
        created: "opprettet",
        skipped: "hoppet over",
        priceDifference: "Prisavvik",
        newSaleEur: "Nysalg (EUR)",
        newSaleNok: "Nysalg (NOK)",
        renewalEur: "Fornyelse (EUR)",
        renewalNok: "Fornyelse (NOK)",
        eurToNokRate: "EUR → NOK-kurs",
        saveRate: "Lagre kurs",
        rateSaved: "Kurs lagret",
        notSet: "ikke satt",
        invalidRate: "Ugyldig kurs",
        government: "Offentlig (Synnex-prisliste)",
        uploadPriceList: "Last opp prisliste",
        dropOrClick: "Dra og slipp filen her, eller klikk for å velge",
        renewalVariants: "Overgangspriser",
        showTransitionPrices: "Vis overgangspriser",
        earnback: "Earnback",
        costPrice: "Kostpris",
        skippedRows: "Hoppet over rader",
        hasIssue: "Varsel",
        collapsedVariantsMessage: "Flere varianter (serviceplan eller tilgangsmodell) er slått sammen til denne raden — det kan finnes et eget produkt som ikke vises separat.",
        unknownOrderActionMessage: "Autodesk har merket denne raden med en handling vi ikke kjenner igjen — prisen er ikke beregnet for denne varianten.",
        unexpectedPairMessage: "Mangler nysalg eller fornyelse, uten at produktet er utgått for salg — bør sjekkes før det selges."
    },
    adminChangeContracts: {
        contractUpdated: "Kontrakt oppdatert",
        contractStatus: "Kontraktstatus",
        active: "Aktiv",
        expired: "Utløpt",
        updateContract: "Oppdater kontrakt"
    },
    adminChangeContractLicense: {
        updatedExpirationDate: "Oppdatert utløpsdato",
        updatedParentLicenseNumber: "Oppdatert foreldre lisensnr.",
        updatedItemType: "Oppdatert varetype",
        changeLicense: "Endre Lisens",
        updateExpirationDate: "Oppdater utløpsdato"
    },
    adminCompany: {
        moveUsersToNewCompany: "Flytt brukere til nytt firma"
    },
    baseCatalog: {
        updatedCourseInCatalog: "Oppdaterte kurset i katalogen.",
        couldNotUpdateCourseInCatalog: "Kunne ikke oppdatere kurset i katalogen.",
        linkToCourseCatalog: "Lenke til kurskatalog",
        icon: "Ikon",
        preamble: "Ingress",
        categories: "Kategorier",
        selectLevel: "Velg nivå",
        selectDuration: "Velg varighet"
    },
    bronnoysundAdmin: {
        syncWithBronnoysund: "Sync. med Brønnøysund",
        soName: "SO navn",
        bsName: "Brreg navn",
        soAddress: "SO adresse",
        bsAddress: "Brreg adresse",
        bsZip: "Brreg postnr.",
        soZip: "SO postnr.",
        bsPostZip: "Brreg postadr.postnr.",
        soPostZip: "SO postadr. postnr.",
        bsCity: "Brreg poststed",
        soCity: "SO poststed",
        bsPostCity: "Brreg postadr. poststed",
        soPostCity: "SO postadr. poststed",
        soPostAddress: "SO postadr.",
        bsPostAddress: "Brreg postadr.",
        activeContracts: "Ant. aktive kontrakter",
        bankruptInBS: "Konkurs i bbreg",
        liquidating: "Avvikles",
        differentAddress: "Ulik adresse",
        differentPostAddress: "Ulik postadresse",
        differentName: "Ulikt navn",
        different: "Ulik"
    },
    bronnoysundDetails: {
        numberOfEmployees: "Antall ansatte",
        postalCode: "Postnummer",
        city: "Poststed",
        district: "Kommune",
        bankrupt: "Konkurs",
        liquidating: "Avvikles"
    },
    changeCourseUsersPassword: {
        selectPassword: "Velg passord",
        selectEmails: "Velg eposter",
        changePasswordsForCourseUsers: "Endre passord for kursbrukere",
        untilDate: "T.o.m dato",
        courseName: "Kursnavn (valgfritt)",
        passwordForCourseUsers: "Passord for kursbrukere",
        generateNewPassword: "Generer nytt passord",
        usedFrom: "Brukt fra",
        usedUntil: "Brukt til",
        inUse: "I bruk",
        useEmail: "Bruk epost"
    },
    companiesCreated: {
        adminEmail: "Admin epost",
        adminName: "Admin navn",
    },
    contractDetailsContainer: {
        startingSale: "Starter salg.",
        futureChangesAreImplemented: "Fremtidige endringer gjennomføres",
        orderDeleted: "Ordre slettet.",
        couldNotDeleteOrder: "Kunne ikke slette ordre.",
        orderHiddenRememberToOpenItAgainAfterChanges: "Ordre skjult, husk å åpne den opp igjen etter endringer.",
        couldNotHideOrder: "Kunne ikke skjule ordre."
    },
    contractSale: {
        approval: "Godkjenning",
        grantLicenseAccess: "Gi lisenstilgang",
        newSale: "Nytt salg",
        makeSale: "Utfør salg",
        newLicense: "Ny lisens",
        internalMessage: "Intern melding"
    },
    deleteCatalog: {
        deletedCourseFromCatalog: "Slettet kurset fra katalogen.",
        couldNotDeleteCourseFromCatalog: "Kunne ikke slette kurset fra katalogen."
    },
    catalog: {
        courseCatalog: "Kurskatalog"
    },
    courseGrid: {
        registrations: "Påmeldinger",
        noConflict: "Ingen konflikt",
        firstNameInstr: "Fornavn instr.",
        lastNameInstr: "Etternavn instr.",
        hideCanceled: "Skjul avlyste",
    },
    createNewCourse: {
        addedCourseToList: "La til kurset i listen.",
        couldNotAddCourseToList: "Kunne ikke legge til kurset i listen.",
        preamble: "Ingress",
        superOfficeComments: "SuperOffice kommentarer",
        addNewCourse: "Legg til nytt kurs"
    },
    deleteCourse: {
        areYouSureYouWantToDeleteCourse: "Er du sikker på at du vil slette kurset?"
    },
    registrationConflict: {
        noDataFound: "Ingen data funnet.",
        conflicts: "Konflikter"
    },
    evaluationEmail: {
        nameOfTemplate: "Navn på malen",
        template: "Mal"
    },
    externalCourses: {
        confirmationOfCourseToRegistrant: "Bekreftelse av kurs til påmelder"
    },
    emailTemplates: {
        emailTemplates: "Epostmaler",
        evaluationEmail: "Evaluering epost",
        externalCourses: "Eksterne kurs",
        confirmationOfCourseRegistration: "Bekreftelse av kurspåmelding",
        movingCourses: "Flytting av kurs",
        cancelingCourse: "Avmelding av kurs"
    },
    tableData: {
        explanationsOfVariousCodes: "Forklaringer på de ulike kodene",
        updatedText: "Oppdarte teksten.",
        couldNotUpdateText: "Kunne ikke oppdatere teksten.",
        address: "Adresse",
        comment: "Kommentar",
        userAddress: "Brukerens adresse",
        userPostCode: "Brukerens postkode",
        userCity: "Brukerens poststed",
        company: "Firma",
        courseName: "Navn på kurs",
        coursereginfo: "Informasjon om kurset",
        date: "Dato",
        dateOld: "Tidligere dato",
        duration: "Varighet",
        durationOld: "Tidligere varighet",
        email: "Epost",
        firstName: "Fornavn",
        lastName: "Etternavn",
        mobile: "Mobilnummer",
        place: "Sted",
        googleMapsLink: "Lenke til kart",
        price: "Pris",
        priceInfo: "Prisinformasjon"
    },
    informationTexts: {
        informationTexts: "Informasjonstekster",
        courseSchedule: "Kursplan",
        generalInformation: "Generell informasjon",
        practicalInformation: "Praktisk informasjon",
        preamble: "Ingress",
        general: "Generell",
        practical: "Praktisk"
    },
    cancelRegistration: {
        canceledCourseParticipant: "Avbestilte kursdeltaker.",
        couldNotCancelCourseParticipant: "Kunne ikke avbestille kursdeltaker.",
        areYouSureYouWantToCancelYourRegistration: "Er du sikker på at du vil avbestille påmeldingen?",
        sendEmailTo: "Send e-post til",
        cancel: "Avbestill"
    },
    createNewRegistration: {
        addedCourseParticipantToList: "La til kursdeltaker i listen.",
        couldNotAddCourseParticipantToList: "Kunne ikke legge til kursdeltaker i listen.",
        newCourseParticipant: "Ny kursdeltaker",
        sendEmailWhenRegistering: "Send epost ved påmelding",
        createNewCourseParticipant: "Opprett ny kursdeltaker"
    },
    editRegistration: {
        changedCourseParticipantInList: "Endret en kursdeltaker i listen.",
        couldNotChangeCourseParticipantInList: "Kunne ikke endre en kursdeltaker i listen.",
        changeCourseParticipant: "Endre kursdeltaker",
        sendEmailOnUpdating: "Send epost ved oppdatering",
        updateCourseParticipant: "Oppdater kursdeltaker"
    },
    moveRegistration: {
        movedRegistration: "Flyttet påmelding.",
        couldNotMoveRegistration: "Kunne ikke flytte påmelding.",
        areYouSureYouWantToMoveCourseDate: "Er du sikker på at du vil flytte kursdato?",
        sendEmailTo: "Send e-post til",
        moveDate: "Flytt dato"
    },
    reactivateRegistration: {
        reactivatedCourseParticipant: "Reaktiverte kursdeltaker.",
        couldNotReactivateCourseParticipant: "Kunne ikke reaktivere kursdeltaker.",
        areYouSureYouWantToReactivateYourRegistration: "Er du sikker på at du vil reaktivere påmeldingen?",
        sendEmailTo: "Send e-post til"
    },
    registrationGrid: {
        cancel: "Avbestill",
        reactivate: "Reaktiver",
        registered: "Registrert",
        cancelled: "Avbestilt",
        newCourseParticipant: "Ny kursdeltaker",
        enrolled: "Påmeldt",
        sendEvaluation: "Send evaluering"
    },
    registration: {
        courseDate: "Kursdato"
    },
    courseReport: {
        theseAreOnCourse: "Disse er på kurs",
        courseDeliveredDuringPeriod: "Kurs levert i perioden",
        includeParticipantsFromFocus: "Inkluder deltakere fra Focus",
        numberOfParticipants: "Ant. deltakere"
    },
    emailLog: {
        subject: "Emne"
    },
    sendCertificate: {
        courseCertificateSent: "Kursbevis sendt",
        errorWhenSendingCourseCertificate: "Feil ved sending av kursbevis",
        areYouSureYouWantToSendCourseCertificates: "Er du sikker på at du vil sende kursbevis?"
    },
    totalReport: {
        sendCourseCertificateAgain: "Send kursbevis igjen",
        sendCourseCertificate: "Send kursbevis",
        showCourseCertificate: "Vis kursbevis",
        dateOfOrder: "Bestillingsdato"
    },
    reports: {
        course: "Kurs",
        search: "Søk",
        emailLog: "Epost logg"
    },
    createNewCategory: {
        addCategoryToList: "La til kategori i listen.",
        couldNotAddCategoryToList: "Kunne ikke legge til kategori i listen.",
        addCategory: "Legg til kategori"
    },
    deleteCategory: {
        deletedCategoryFromList: "Slettet kategori fra listen.",
        couldNotDeleteCategoryFromList: "Kunne ikke slette kategori fra listen.",
        areYouSureYouWantToDeleteCategory: "Er du sikker på at du vil slette kategori?"
    },
    editComputerEquipment: {
        updatedComputerEquipmentInList: "Oppdaterte datautstyr i listen.",
        couldNotUpdateComputerEquipmentInList: "Kunne ikke oppdatere datautstyr i listen.",
        updateComputerEquipment: "Oppdater datautstyr"
    },
    computerEquipment: {
        serialNumber: "Serienummer"
    },
    createNewDuration: {
        addedNewDurationToList: "La til ny varighet i listen.",
        couldNotAddNewDurationToList: "Kunne ikke legge til ny varighet i listen.",
        value: "Verdi",
        unit: "Enhet",
        hours: "timer",
        days: "dager",
        addDuration: "Legg til varighet"
    },
    deleteDuration: {
        deletedDurationFromList: "Slettet varighet fra listen.",
        couldNotDeleteDurationFromList: "Kunne ikke slette varighet fra listen.",
        areYouSureYouWantToDeleteDuration: "Er du sikker på at du vil slette varighet?"
    },
    copyInstructor: {
        createInstructor: "Opprett instruktør"
    },
    createNewInstructor: {
        addInstructor: "Legg til instruktør"
    },
    deleteInstructor: {
        deletedInstructorFromList: "Slettet instruktør fra listen.",
        couldNotDeleteInstructorFromList: "Kunne ikke slette instruktør fra listen.",
        areYouSureYouWantToDeleteInstructor: "Er du sikker på at du vil slette instruktør?"
    },
    editInstructor: {
        changedInstructorInList: "Endret instruktør i listen.",
        changeInstructor: "Endre instruktør",
        updateInstructor: "Oppdater instruktør"
    },
    createNewLevel: {
        addedLevelToList: "La til nivå i listen.",
        couldNotAddLevelToList: "Kunne ikke legge til nivå i listen.",
        addLevel: "Legg til nivå",
        deletedLevelFromList: "Slettet nivået fra listen.",
        couldNotDeleteLevelFromList: "Kunne ikke slette nivået fra listen.",
        areYouSureYouWantToDeleteLevel: "Er du sikker på at du vil slette nivået?"
    },
    deletePicture: {
        deletedImageFromList: "Slettet bildet fra listen.",
        couldNotDeleteImageFromList: "Kunne ikke slette bildet fra listen.",
        areYouSureYouWantToDeletePicture: "Er du sikker på at du vil slette bildet?"
    },
    picture: {
        uploadNewImage: "Last opp nytt bilde"
    },
    copyPlace: {
        couldNotAddPlace: "Kunne ikke legge til sted.",
        createPlace: "Opprett sted"
    },
    createNewPlace: {
        couldNotAddLocationToList: "Kunne ikke legge til sted i listen.",
        addLocation: "Legg til sted"
    },
    deletePlace: {
        deletedPlaceFromList: "Slettet sted fra listen.",
        couldNotDeleteLocationFromList: "Kunne ikke slette sted fra listen.",
        areYouSureYouWantToDeleteLocation: "Er du sikker på at du vil slette stedet?"
    },
    editPlace: {
        updatedPlace: "Oppdaterte sted.",
        couldNotUpdatePlace: "Kunne ikke oppdatere sted.",
        changeLocation: "Endre sted",
        updateLocation: "Oppdater sted"
    },
    place: {
        updateFromSuperOffice: "Oppdater fra SuperOffice"
    },
    createNewPrice: {
        addedPriceToList: "La til pris i listen.",
        couldNotAddPriceToList: "Kunne ikke legge til pris i listen.",
        priceFormat: "Prisformat",
        addPrice: "Legg til pris"
    },
    deletePrice: {
        deletedPriceFromList: "Slettet prisen fra listen.",
        couldNotDeletePriceFromList: "Kunne ikke slette prisen fra listen.",
        areYouSureYouWantToDeletePrice: "Er du sikker på at du vil slette prisen?"
    },
    resources: {
        resources: "Resurser",
    },
    courses: {
        courseAccess: "Kurstilgang",
        usedFrom: "I bruk f.o.m",
        usedUntil: "I bruk t.o.m",
        passwordForCourse: "Passord for kurs",
        createNewCourse: "Opprett nytt kurs",
        numberOfParticipants: "Antall deltakere",
        coursePrice: "Kurspris",
        includeCanceledCourses: "Inkluder avlyste kurs",
        answeredSurvey: "Besvart spørreundersøkelse",
        sentCertificate: "Sendt sertifikat"
    },
    createEmail: {
        emailInternalName: "Epost internt navn",
        createEmail: "Opprett epost"
    },
    addContract: {
        newContract: "Ny kontrakt",
        thereAreNoAccountsForThisCustomer: "Det er ingen kontoer på denne kunden. Opprett en person i firmaet før du oppretter en kontrakt.",
        months: "måneder",
        year: "år",
        contractStart: "Kontraktstart",
        contractRenewal: "Fornyelsesdato",
        selectContractType: "Velg kontrakttype",
        retrievesEmployees: "Henter ansatte"
    },
    addCustomerGroup: {
        companyAddedToGroup: "Firma lagt til i konsern.",
        couldNotAddCompanyToGroup: "Kunne ikke legge til firma i konsern."
    },
    addImport: {
        ticketID: "Sak ID",
        usedTime: "Medgått tid",
        numberOfMessages: "Antall meldinger"
    },
    addNewUser: {
        contractUpdated: "Kontrakt oppdatert.",
        cannotHaveMoreUsersThanThereAreSeats: "Kan ikke ha flere brukere enn det er seter.",
        updatesUsersOnContract: "Oppdaterer brukere på kontrakt.",
        numberOfUsersOnContract: "Antall brukere på kontrakten"
    },
    allContractsDetailsGrid: {
        pricePerItem: "Pris pr. stk.",
        monthlyValue: "Månedsverdi",
        netGain: "Netto gevinst",
        residualValueAtYearStart: "Restverdi ved årsskifte",
        totalCost: "Sum pris"
    },
    allContractsGrid: {
        invoiceResponsible: "Fakturaansvarlig",
        futureChanges: "Fremtidige endringer",
        invoiceInterval: "Kontraktvarighet"
    },
    assignLicenseRight: {
        changesLicenseAccess: "Endrer lisenstilgang.",
        couldNotChangeLicenseRights: "Kunne ikke endre lisensrettigheter."
    },
    basicCustomerDetails: {
        seeCustomerInformationInSuperOffice: "Se kundeinformasjon i SuperOffice",
        customerContact: "Kundekontakt",
        companySettings: "Firmainnstillinger",
        administrator: "Administrator",
        language: "Språk",
        requiresTwoFactorAuthentication: "Krever 2FA",
        federatedDomain: "Federert domene" 
    },
    basicSupport: {
        contractNumber: "Kontraktnummer",
        seeNext: "Se neste",
        agreementType: "Avtaletype",
        includedForGroup: "Brukerstøtte inkludert for konsern",
        includedInSubscription: "Brukerstøtte inkludert i abonnement",
        groupDeal: "Konsernavtale",
        individualDeal: "Individuell avtale",
        noRestrictions: "Ingen begrensninger",
        users: " brukere",
        nextInvoice: "Neste faktura"
    },
    ceateFocusAccount: {
        emailIsNotValid: "Eposten er ikke gyldig.",
        newInvitationSent: "Ny invitasjon sendt.",
        completingAccount: "Fullfører konto.",
        approvesFocusAccount: "Godkjenner Focuskonto.",
        createAccount: "Oppretter konto.",
        sendNewInvitation: "Send ny invitasjon",
        completeAccount: "Fullfør konto",
        approveAccount: "Godkjenn konto",
        openAccount: "Opprett konto",
        retrievesAccountStatus: "Henter status på konto",
        createFocusAccount: " Opprett Focuskonto",
        accountStatus: "Status på konto",
        requestedCompany: "Firma brukeren ber om tilgang til"
    },
    credit: {
        creditingDone: " Kreditering utført.",
        couldNotPerformCrediting: "Kunne ikke utføre kreditering.",
        amountAfterBalance: "Beløp etter saldo",
        message: "Melding"
    },
    customerDetails: {
        focusAccounts: "Focuskontoer",
        peopleInSuperOffice: "Personer i SuperOffice",
        companyGroup: "Firmagruppe",
        createCompanyGroup: "Opprett firmagruppe",
        loggedInToMyPage: "Logget inn på Min Side",
        viewByGroup: "Vis for gruppe",
        showDeleted: "Vis slettede"
    },
    customerProductList: {
        domains: "Domener",
        coordinators: "Koordinatorer",
        hasLicensing: "Har lisensiering",
        items: "Varer",
        forGroup: "For gruppe"
    },
    customerProductListGrid: {
        licenseTypeDoesNotHaveLicensing: "Lisenstypen har ikke lisensiering",
        accessHistory: "Tilgangshistorikk"
    },
    customerProductListGridRenderer: {
        removeOldAccesses: "Fjern tilganger eldre enn",
        givenAccess: "Gitt tilgang",
        removedAccess: "Fjernet tilgang",
        givenCoordinator: "Gitt koordinator",
        removedCoordinator: "Fjernet Koordinator",
        moved: "Flyttet",

        productVersion: "Produktversion"
    },
    deleteCustomerGroup: {
        customerGroupDeleted: "Datterselskap fjernet.",
        couldNotDeleteCustomerGroup: "Kunne ikke fjerne datterselskap.",
        areYouSureYouWantToDeleteCompanyDepartment: "Er du sikker på at du vil slette firma / avdeling?"
    },
    domain: {
        automaticDomainApprovalDone: "Automatisk lisensgodkjenning utført.",
        failedToPerformAutomaticDomainValidation: "Kunne ikke utføre automatisk lisensgodkjenning.",
        automaticDomainApproval: "Automatisk lisensgodkjenning"
    },
    editFocusAccount: {
        reopenedFocusAccount: "Gjenåpnet Focuskonto.",
        couldNotReopenFocusAccount: "Kunne ikke gjenåpne Focuskonto",
        changedAdmin: "Endret admin.",
        changedToCoAdmin: "Endret til co-admin.",
        resendingInvitation: "Sender invitasjon på nytt.",
        deletesFocusAccount: "Sletter Focuskonto.",
        changeFocusAccount: "Endre Focuskonto",
        changeCompany: "Endre firma",
        selectAsAdmin: " Velg som admin",
        selectAsCoAdmin: "Velg som co-admin",
        resendInvitation: "Send invitasjon på nytt",
        reopenFocusAccount: "Gjenåpne Focuskonto",
        deleteWithoutEmail: "Slett uten epost",
        deleteWithEmail: "Slett med epost",
        changeCompanyFor: "Endre firma for",
        moveUserToNewCompany: "Flytt bruker til nytt firma",
        changeEmailFor: "Endre epost for",
        retireInSO: "Pensjoner i SuperOffice",
        requestedCompany: "Firma brukeren ber om tilgang til",
        resetMfa: "Tilbakestill Tofaktor",
        selectAsUser: "Velg som bruker",
    },
    externalAccess: {
        couldNotSelectCompanyToCustomer: "Kunne ikke velge firma til kunde.",
        selectCompanyToCustomer: "Velg firma til kunde"
    },
    license: {
        canNotHaveMoreAccessesThanSeatsOnNamedUserLicenses: "Kan ikke ha flere tilganger enn seter på navngitt bruker lisenser.",
        numberOfUsersOnLicense: "Antall brukere på lisensen"
    },
    mergeContracts: {
        combinesContracts: "Kombinerer kontrakter",
        targetContractNotSelected: "Målkontrakt ikke valgt",
        selectTargetContract: "Velg målkontrakt"
    },
    moveContracts: {
        movingContracts: "Flytter kontrakter",
        selectCompanyYouWantToMoveTo: "Velg firma du vil flytte til",
        hereYouCanSelectContractAndLicensesYouWantToMove: "Her kan du velge kontrakt og lisenser du ønsker å flytte."
    },
    orderOverview: {
        orderDeleted: "Ordre slettet.",
        couldNotDeleteOrder: "Kunne ikke slette ordre."
    },
    support: {
        noUserSupportAgreement: "Ingen brukerstøtteavtale"
    },
    supportGrid: {
        usersOnTheAgreement: "Brukere på avtalen",
        transactions: "Transaksjoner",
        isOnSupport: "Er på brukerstøtte",
        customerNoInNimbus: "Kundenr. i Nimbus",
        software: "Programvarer",
        estimatedHourlyBalance: "Estimert timesaldo",
        spent: "Oppbrukt",
        amountBalance: "Beløpsaldo",
        caseNo: "Saksnr.",
        caseDate: "Saksdato",
        transactionDate: "Transaksjonsdato",
        text: "Tekst",
        ownedBy: "Behandler",
        hours: "Timer",
        balance: "Saldo",
        price15minutes: "Pris pr kvarter",
        userOnSupportAgreement: "På avtale",
        ticketId: "Sak ID",
        tickets: "Saker",
        message: "Melding",
        createdAt: "Opprettet dato",
        createdBy: "Opprettet av",
        status: "Status",
    },
    editCompanyDetails: {
        changeCompanyDetails: "Endre firmadetaljer",
        norwegian: "Norsk",
        english: "Engelsk",
        twoFactorAuthentication: "To-faktor autentisering",
        noEmail: "ingen epost",
        selectCoAdministrators: "Velg co-administratorer",
        federationAndSSO: "Federering og SSO",
        tenantId: "Tenant ID",
        clientId: "Client ID",
        domain: "Domene",

    },
    editEmails: {
        emailUpdated: "Epost oppdatert.",
        triggerMade: "Trigger laget.",
        testEmailSent: "Test epost sendt",
        triggerDeleted: "Trigger slettet",
        shownToCustomer: "Vises til kunde",
        emailInternalName: "Epost internt navn",
        updateEmailContent: "Oppdater epost innhold",
        typeOfTrigger: "Type trigger",
        trigger: "Trigger",
        missingEnglishEmail: "mangler engelsk email",
        missingNorwegianEmail: "mangler norsk email",
        selectTrigger: "Velg trigger",
        newTrigger: "Ny trigger",
        emailRecipient: "Epost mottaker",
        forEnglishLanguage: "For engelsk språk",
        saveEmailInSuperOffice: "Lagre epost i SuperOffice",
        numberOfDaysBetweenTriggerAndEvent: "Antall dager mellom trigger og event",
        updateTrigger: "Oppdater trigger",
        createTrigger: "Lag trigger",
        sendTestEmail: "Send test epost",
        deleteTrigger: "Slett trigger"
    },
    editLicense: {
        licenseChangesSaved: "Lisens endringer lagret.",
        endNow: "Avslutt nå",
        endAtTheNextDueDate: "Avslutt ved neste forfall",
        custom: "Egendefinert",
        addNewItem: "Legg til ny vare",
        dateOfSale: "Salgsdato",
        terminateLicense: "Avslutt lisens",
        change: "Endring",
        salePrice: "Salgspris",
        hasFutureChanges: "Har fremtidige endringer"
    },
    emailComponents: {
        componentChanged: "Komponent endret.",
        componentDeleted: "Komponent slettet",
        saveComponent: "Lagre komponent",
        deleteComponent: "Slett komponent"
    },
    emailContainer: {
        emailTemplates: "Epost maler",
        emailComponents: "Epost komponenter"
    },
    emailList: {
        immediately: "Med en gang",
        noTrigger: "Ingen trigger",
        triggerEvent: "Trigger event",
        daysAfterEvent: "Dager etter hendelse"
    },
    errorLog: {
        loginFailed: "Misslykket pålogging",
        userAgent: "Brukeragent",
        licenseNumber: "Lisensnummer",
        companyNumber: "Firmanummer",
        IPAdress: "IP-adresse",
        unavailableLicenses: "Utilgjengelige lisenser",
        unavailableLicense: "Utilgjengelig lisens",
        request: "Request",
        error: "Feil",
        inequalityOnUnit: "Ulikhet på enhet",
        oldValue: "Gammel verdi",
        newValue: "Ny verdi"
    },
    gptDefinations: {
        newFunction: "Ny funksjon",
        getBackup: "Hent backup",
        functionName: "Funksjonsnavn",
        shortDescriptionSoThatGptUnderstandsWhenToUseFunction: "Kort beskrivelse slik at GPT forstår når den skal bruke funksjonen.",
        content: "Innhold",
        informationGptRetrievesWhenFunctionIsCalled: "Informasjonen GPT henter ut når funksjonen blir kalt.",
        createNewFunction: "Opprett ny funksjon"
    },
    gptHelper: {
        findRightPage: "Finn riktig side",
        pageAssistance: "Sideassistanse",
        clearChat: "Tøm chat",
        writeAMessage: "Skriv en beskjed..."
    },
    gptOverview: {
        pages: "Sider",
        functions: "Funksjoner"
    },
    gptRouteDefinition: {
        updatedRoute: "Oppdatert route",
        savedAsBackup: "Lagret som backup",
        newPage: "Ny side",
        getBackup: "Hent backup",
        detailedDescriptionOfWhatIsOnPageSoGptCanAnswerQuestionsAboutPage: "Detaljert beskrivelse av hva som finnes på siden så GPT kan svare på spørsmål om siden.",
        detailedDescription: "Detaljert beskrivelse",
        selected: "Valgt",
        saveRoute: "Lagre route"
    },
    activeUsersGrid: {
        version: "Versjon",
        licenseNo: "Lisensenr.",
        offline: "Frakoblet",
        maxSeats: "Maks seter",
        loggedInNow: "Innloggede nå",
        onlyActiveUsers: "Kun aktive brukere",
        connected: "Tilkoblet",
        mainProductsOnly: "Kun hovedprodukter",
    },
    loan: {
        logOnDuration: "Påloggingstid",
        timeZone: "Tidssone",
        newDevice: "Ny enhet"
    },
    machine: {
        diskID: "Disk ID"
    },
    expiredLicense: {
        subscription: "Abonnement",
        maintenance: "Vedlikehold"
    },
    licenseChanges: {
        terminatedLicenses: "Avsluttede lisenser",
        reducedSeats: "Reduserte seter",
        newSeats: "Nye seter",
        newLicenses: "Nye lisenser",
    },
    licenseUsageGrid: {
        users: "Brukere",
        logonsPerSeat: "Pålogginger/Sete"
    },
    machineInfo: {
        windowsUsername: "Windows brukernavn",
        domainName: "Domenenavn",
        machineName: "Maskinnavn",
        localFolder: "Lokal mappe",
        systemSerialNumber: "Systemets serienummer",
        systemDiskSignature: "System disk signatur",
        operatingSystem: "Operativ system",
        architecture: "Arkitektur"
    },
    nlm: {
        newOfflineFile: "Ny offline fil",
        existingOfflineFiles: "Eksisterende offline filer",
        createOfflineNlm: "Lag offline NLM"
    },
    nlmGrid: {
        generateNlmFile: "Generer NLM fil",
        downloadFile: "Last ned fil",
        offlineNlmFile: "Offline NLM fil",
        createFile: "Opprett fil",
        NlmFileWillBeCreatedAndWillBeSentToYouByEmail: "NLM filen vil bli opprettet og sendt til deg på epost",
    },
    personActivityGrid: {
        mergeProductsForUsers: "Slå sammen produkter for brukere"
    },
    rejectedLoginGrid: {
        licensingSystem: "Lisenssystem",
        approved: "Godkjente",
        rejected: "Avviste",
        rejectedPersent: "Avviste (%)"
    },
    loginError: {
        noLicense: "Ingen lisens",
        showDetails: "Vis detaljer"
    },
    minSideInterests: {
        addProductsTo: "Legg produkter til"
    },
    minSideStatus: {
        changeSaved: "Endring lagret",
        activateStatusMessageOnMyPage: "Aktiver statusmelding på Min Side",
        statusMessageNorwegian: "Statusmelding norsk",
        statusMessageEnglish: "Statusmelding engelsk",
        saveStatusMessage: " Lagre statusmelding"
    },
    monthlyReports: {
        companyChurn: "Firma churn (%)",
        companyGrowth: "Firmavekst (%)",
        licenseChurn: "Sete churn (%)",
        licenseGrowth: "Setevekst (%)",
        incomeChurn: "Inntekts churn (%)",
        incomeGrowth: "Inntektsvekst (%)",
        licenseDiff: "Sete diff.",
        incomeDiff: "MRR Inntekts diff.",
        incomeMRR: "MRR Inntekt",
        incomeARR: "ARR Inntekt"
    },
    moveContractInvoice: {
        changeInvoiceDate: "Endrer fakturadato.",
        moveCost: "Flyttkostnad",
        moveInvoiceDate: "Flytt fakturadato",
        newInvoiceDate: "Ny fakturadato"
    },
    moveUsersToNewCompany: {
        noCompanySelected: "Ikke valgt firma",
        movingOfUsersFinished: "Flytt av brukere fullført.",
        youMustChooseACompanyToMoveTo: "Du må velge et firma å flytte til",
        startsMovingOfUsers: "Starter flytt av brukere.",
        selectUsersToMove: "Velg brukere å flytte",
        moveUsersToNewCompany: "Flytt brukere til nytt firma",
        selectAllAccounts: "Velg alle kontoer",
        companyYouAreMovingFrom: "Firma du flytter fra",
        chooseCompanyToMoveTo: "Velg firma å flytte til",
        newDomain: "Nytt domene",
        newEmail: "Ny epost"
    },
    newCompany: {
        customerCreated: "Kunde opprettet.",
        noCustomerNumber: "Ingen kundenummer",
        noOrgNo: "Ingen org.nr.",
        createCustomer: "Opprett kunde",
        selectACompanyFromSuperOffice: "Velg firma fra SuperOffice",
        selectCustomer: "Velg kunde",
        noPersonsWithEmail: "Ingen personer med e-post",
        selectAdmin: "Velg admin",
        sendEmailToAdmin: "Send epost til admin",
        createCompany: "Opprett firma",
        createAdmin: "Opprett admin"
    },
    newContractContainer: {
        changedContractInformation: "Endret kontraktinformasjon.",
        isByggdataContract: "Må velge selger på Byggdata kontrakter.",
        startingSale: "Starter salg.",
        contractIsCreated: "Kontrakt opprettes"
    },
    addGroup: {
        newGroupAdded: "Ny gruppe lagt til.",
        couldNotAddNewGroup: "Kunne ikke legge til ny gruppe."
    },
    addNewVersion: {
        newVersionCreated: "Ny versjon opprettet.",
        couldNotCreateNewVersion: "Kunne ikke opprette ny versjon",
        selectName: "Velg navn"
    },
    addProducts: {
        productAddedToGroup: "Produkt lagt til i gruppe.",
        couldNotAddProductToGroup: "Kunne ikke legge til produkt i gruppe.",
        contractInfo: "Kontraktinfo",
        nimbusCode: "Nimbus kode",
        nimbusGroupCode: "Nimbus gruppekode",
        recurringInventoryItemId: "Gjentakende vare-ID",
        setupInventoryItemId: "Setup Inventory Item ID",
        setupPrice: "Pris etableringsvare",
        startupItemId: "Startup Item ID",
        newLicense: "Ny lisens",
        idForNextItem: "ID til neste vare",
        quantityBeforeNextItem: "Antall før neste vare"
    },
    copyLicenseAccess: {
        licenseYouWantToCopy: "Lisens du vil kopiere"
    },
    deleteProductCategtory: {
        groupDeleted: "Gruppe slettet.",
        couldNotDeleteGroup: "Kunne ikke slette gruppe.",
        deleteProductCategory: " Slett produktkategori"
    },
    deleteRelatedProduct: {
        productDeleted: "Produkt slettet.",
        couldNotDeleteProduct: "Kunne ikke slette produktet."
    },
    deleteVersion: {
        versionDeleted: "Versjon slettet.",
        couldNotDeleteVersion: "Kunne ikke slette versjon."
    },
    editProduct: {
        changeDone: "Endring utført.",
        failedToExecuteChange: "Kunne ikke utføre endring.",
        newProductCreated: "Nytt produkt opprettet.",
        couldNotCreateNewProduct: "Kunne ikke opprette nytt produkt.",
        example: "Eksempel",
        mainProduct: "Hovedprodukt (Kun for delprodukter)",
        urlToWebsite: "Url til nettside (Kun for Webapp)",
        vismaArticleID: "Visma article ID",
        supportCategory: "Brukerstøttekategori",
        descriptionOfRequirements: "Beskrivelse av krav",
        productDescription: "Produktbeskrivelse",
        linkToProductPage: "Lenke til produktsiden",
        notToBeLicensedInNimbus: "Skal ikke lisensieres i Nimbus"
    },
    editVersion: {
        newFile: "Ny fil",
        fileUpdated: "Fil oppdatert",
        failedToUpdateFile: "Kunne ikke oppdatere fil.",
        fileDeleted: "Fil slettet.",
        couldNotDeleteFile: "Kunne ikke slette fil.",
        releaseDate: "Utgivelsesdato",
        selectTodaysDate: "Velg dagens dato",
        fileType: "Filtype",
        programVersion: "Programversjon",
        useAsLastDownload: "Bruk som siste nedlasting",
        updateFile: "Oppdater fil",
        deleteFile: "Slett fil"
    },
    licenseAccessGrid: {
        mergeInFields: "Slå sammen på felt",
        userID: "Bruker ID",
        maintenanceExpiration: "Vedlikehold utløp",
        productStructure: "Produktstruktur"
    },
    groups: {
        deleteProductGroup: "Slett produktgruppe",
        productCategories: "Produktkategorier",
        editDescription: "Endre beskrivelse",
        description: "Beskrivelse",
        changeProductGroupDescription: "Endre produktgruppe beskrivelse",
        productCategory: "Produktkategori",
        startupPUK: "Oppstart PUK",
        renewalPUK: "Fornyelse PUK",
        maintenancePUK: "Vedlikehold PUK",
    },
    import: {
        itemHasBeenUpdated: "Varen er oppdatert.",
        couldNotUpdateItem: "Kunne ikke oppdatere varen.",
        update: "Oppdater",
        newItem: "Ny vare",
        canBeUpdated: "Kan oppdateres",
        costPrice: "Kostpris",
        itemType: "Vare type",
        interval: "Intervall",
        requiredQuantity: "Ant. før tilleggsvare",
        userSupportIncluded: "Brukerstøtte inkl.",
        showItemsWithoutChanges: "Vis varer uten endringer"
    },
    items: {
        seeContractInfo: "Se kontraktinfo",
        nimbusProductCode: "Nimbus produktkode",
        setupInventoryItem: "Oppstartsvare",
        supportIncluded: "Support inkludert",
        licensingInNimbus: "Lisensiering i Nimbus",
        canBeSold: "Kan selges",
        connectedItem: "Tilknyttet vare"
    },
    productList: {
        parentName: "Foreldrenavn",
        interests: "Interesser",
        productCode: "Prokuktkode"
    },
    productStructureGrid: {
        groups: "Grupper",
        contractItems: "Kontraktvarer",
        itemsImport: "Import av varer",
        autodeskImport: "Import av autodesk",
        myPageInterests: "Min Side interesser"
    },
    productVersionGrid: {
        versionName: "Versjonsnavn",
        numberOfFiles: "Ant. filer"
    },
    deleteContactsError: {
        errorMessageSetAsHandled: "Feilmelding satt som håndtert.",
        couldNotSetErrorMessageAsHandled: "Kunne ikke sette feilmelding som håndtert.",
        areYouSureYouWantToSetAsHandled: "Er du sikker på at du vil sette som håndtert?",
        errorMessageIsSetAsHandledInDatabase: "Feilmeldingen blir satt som håndtert i databasen."
    },
    overview: {
        failedLogins: "Misslykkede pålogginger",
        lastSales: "Siste salg",
        newCompanyRequests: "Nye firmaforespørsler",
        failedOrders: "Mislykkede ordre",
        offlineLicensesRenewal: "Offline lisenser fornyelse",
        reason: "Årsak",
        startedUsing: "Startet å bruke",
        orderID: "Ordre ID",
        daysToRenewal: "Dager til fornyelse",
        terminates: "Avsluttes",
        proposals: "Tilbud"
    },
    pageTitle: {
        noCustomerSelected: "Ingen kunde valgt..."
    },
    periodChurnReport: {
        monthlyValue: "Månedlig verdi",
        annualValue: "Årlig verdi",
        retrieveData: " Hent data",
        seatChurn: "Sete churn",
        seatGrowth: "Sete vekst",
        incomeChurn: "Inntekt churn",
        incomeGrowth: "Inntekt vekst",
        startSeats: "Seter start",
        endSeats: "Seter slutt",
        startIncome: "Inntekt start",
        endIncome: "Inntekt slutt",
        incomeDiff: "Endring inntekt",
        seatsDiff: "Endring seter",
        all: "Alle"
    },
    personsInSuperOffice: {
        haveAccount: "Har konto",
        deletedAccounts: "Slettede kontoer",
        onlyWithoutAccount: "Bare uten konto"
    },
    productUsageChart: {
        licenseUsage: "Lisensbruk",
    },
    releaseSession: {
        loanReleasedItMayTakeSomeTimeForItToAppear: "Lån frigjort. Det kan ta litt tid før det vises."
    },
    newSales: {
        newSales: "Nye salg",
    },
    newSalesGrid: {
        establishmentItem: "Etableringsvare",
        establishmentItemName: "Etableringsvarenavn",
        saleCostPrice: "Kostpris salg",
        saleContributionMargin: "DB salg",
        recurringCostPrice: "Kostpris gjentagende",
        recurringContributionMargin: "ACV",
        differentInVisma: "Ulik i Visma"
    },
    renewalsGrid: {
        timesInvoicedInPeriod: "Ant. faktureringer i periode",
        activeNextInvoice: "Skal fornyes"
    },
    searchBar: {
        somethingWentWrong: "Noe gikk galt",
        working: "Jobber...",
        retrievingFocusAccounts: "Henter Focuskontoer...",
        findCompanyForFocusAccount: "Finn firma for Focuskonto",
        createCustomer: "Opprett kunde",
    },
    secretPage: {
        selectPage: "Velg side"
    },
    sessionDetails: {
        details: "Detaljer",
        licenseType: "Lisenstype",
        loggedInToMyPage: "Logget inn på Min Side",
        loginTimeInSeconds: "Påloggingstid i sekunder",
        containerProduct: "Container produkt",
        containerVersion: "Container versjon",
        processID: "Prosess ID",
        windowsUser: "Windowsbruker"
    },
    signalRContext: {
        failedToConnectToSignalR: "Kunne ikke koble til signalR",
        actionExecuted: "Handling utført",
        step: "Steg",
        infoFetched: "Info hentet",
        orderValidated: "Ordre validert",
        userRightsValidated: "Brukerrettigheter validert"
    },
    supportReport: {
        startingBalance: "Startsaldo",
        production: "Produksjon",
        finalBalance: "Sluttsaldo",
        income: "Inntekt",
        showNoChanges: "Vis firmaer uten endringer",
    },
    webUpdates: {
        webUpdates: "Web oppdateringer",
        seconds: "Sekunder",
        files: "Filer",
        size: "Størrelse"
    },
    usersWithoutCompany: {
        country: "Land"
    },
    validateEmail: {
        askUserToCreatePasswordFromMyPage: "Be bruker om å opprette passord fra Min Side.",
        createAccountOnUser: "Opprett konto på bruker.",
        noActionRequired: "Ingen handling kreves.",
        userHasBeenSentAnInvitationByEmailEtc: "Bruker er sendt invitasjon på email og må godkjenne den. Alternativt kan velge 'glemt passord' på Min Side.",
        administratorInCompanyMustApproveAccountRequestEtc: "Administrator i firmaet må godkjenne kontoforespørsel. Hvis bruker logger inn på Min Side kan de sende en ny request til administrator.",
        askUserToLoginToMyPageAndCompleteRegistration: "Be bruker logge inn på Min Side og fullføre registrering.",
        checkFocusAccount: "Sjekk Focuskonto",
        emailYouWantToCheckFocusAccountStatusOn: "Epost du vil sjekke Focuskonto status på.",
        checkFocusAccountStatus: "Sjekk Focuskonto status",
        focusAccountStatus: "Focuskonto status",
        statusOnFocusAccount: "Status på Focuskonto",
        actionRequired: "Handling som kreves",
        userSupportStatus: "Status på brukerstøtte",
        other: "Annet",
        userHasLoggedInToMyPage: "Bruker har logget inn på Min Side.",
        accountBlockedInWebKua: "Konto blokkert i WebKua.",
        personRetiredInWebKua: "Person sluttet i WebKua",
        accountChanges: "Kontoendringer",
        performedBy: "Utført av"
    },
    webkuaChart: {
        showGraphAsLine: "Vis graf som linje",
        selectProductsTimePeriodEtcAndRefreshTableToRetrieveData: "Velg produkter, tidsperiode osv. og refresh tabellen for å hente data.",
        selectDatasetToDisplayGraph: "Velg datasett for å vise graf.",
        thereIsNoDataToDisplayForSelectedPeriod: "Det er ingen data å vise for den valgte perioden.",
        ifYouHaveMadeChangesToSearchCriteriaEtc: "Hvis du har gjort endringer i søkekriteriene, husk å trykke på 'Refresh' knappen for å hente ny data.",
        emptyProductListCompanySelectionSelectsAllProductsCompanies: "Tom produktliste / firmautvalg velger alle produkter / firmaer.",
        noDataInTheSearch: "Ingen data i søket",
    },
    webkuaTable: {
        exportToExcel: "Eksporter til Excel",
        noVisibleExportColumns: "Vis minst én kolonne som kan eksporteres før du eksporterer til Excel."
    },
    helpers: {
        noDate: "Ingen dato",
        valueMissing: "Mangler verdi",
        noAccountOnEmail: "Ingen konto på email",
        noKnownIssues: "Ingen kjente problemer",
        invitationExists: "Invitasjon finnes",
        accountRequestExists: "Kontoforespørsel finnes",
        missingPassword: "Mangler passord i Webkua",
        userHasNotFinishedRegistration: "Bruker har ikke fullført registrering"
    },
    requestUtils: {
        configurationSaved: "Konfigurasjon lagret",
        configurationReset: "Konfigurasjon tilbaksstilt"
    },
    baseCourse: {
        updatedCcourseInList: "Oppdaterte kurset i listen.",
        couldNotUpdateCourseInList: "Kunne ikke oppdatere kurset i listen.",
        updatedCourseInListAndSentAnEmailToContactPerson: "Oppdaterte kurset i listen og sendte email til kontaktperson.",
        unknownCourse: "Ukjent kurs.",
        linkToCourse: "Lenke til kurs",
        cancelCourse: "Avlys kurset",
        doNotPublishCourse: "Ikke publiser kurset",
        goToCourse: "Gå til kurset",
        registrant: "Påmelder",
        courseConfirmationEmailTemplate: "Kursbekreftelse epostmal",
        template: "Mal",
        sendConfirmation: "Send bekreftelse",
        preamble: "Ingress",
        superOfficeComments: "SuperOffice kommentarer",
        duplicate: "Duplikat",
        day: "dag"
    },
    standard: {
        payerCode: "Betalingskode",
        id: "Id",
        contractNumber: "Kontraktnummer",
        errorMessage: "Feilmelding",
        gettingData: "Henter data...",
        lastUsed: "Sist brukt",
        contractResponsible: "Kontraktsansvarlig",
        salePrice: "Salgspris",
        licenseChanges: "Lisensendringer",
        invoiceContactPerson: "Faktura Kontaktperson",
        invoiceReference: "Faktura referanse",
        futureChange: "Fremtidig endring",
        reason: "Årsak",
        email: "Epost",
        phone: "Telefon",
        organisationNumber: "Org.nr.",
        decline: "Avslå",
        cancel: "Avbryt",
        remove: "Fjern",
        open: "Åpne",
        company: "Firma",
        processRequest: "Behandle forespørsel",
        companyName: "Firmanavn",
        adminFirstName: "Admin fornavn",
        adminLastName: "Admin etternavn",
        date: "Dato",
        contracts: "Kontrakter",
        companyNo: "Firmanr.",
        contractNo: "Kontraktnr.",
        contractType: "Kontrakttype",
        startDate: "Startdato",
        nextInvoiceDate: "Neste faktura dato",
        nextInvoiceCost: "Neste faktura pris",
        academicVersion: "Akademisk versjon",
        note: "Merknad",
        group: "Gruppe",
        productName: "Produktnavn",
        recurringItem: "Gjentagende vare",
        type: "Type",
        invoiceInterval: "Kontraktslengde",
        seats: "Seter",
        oneTimeDiscount: "Engangsrabatt (%)",
        //recurringDiscount: "Gjentagende rabatt (%)",
        recurringDiscount: "Fornyelsesrabatt (%)",
        discount: "Rabatt",
        client: "Klient",
        residualValue: "Restverdi",
        recidualValueAtYearStart: "Restverdi ved start av nytt år",
        month: "Måned",
        year: "År",
        nextInvoicingDate: "Neste fakturadato",
        newSale: "Nytt salg",
        licenseNumber: "Lisensnr.",
        name: "Navn",
        expirationDate: "Vedlikeholdsstopp",
        terminationDate: "Sluttdato",
        discountPercent: "Rabatt (%)",
        companyNumber: "Kundenr.",
        customerName: "Kundenavn",
        showOnlyTerminationDate: "Vis bare for sluttdato",
        activationDate: "Aktiveringsdato",
        orderDate: "Bestillingsdato",
        orderType: "Ordretype",
        errorText: "Feilmelding",
        changedBy: "Endret av",
        activeOrder: "Aktiv ordre",
        deleted: "Slettet",
        requestDate: "Forespørseldato",
        inNimbus: "I Nimbus",
        inSuperoffice: "I SuperOffice",
        blockedInNimbus: "Blokkert i Nimbus",
        blockedInCosmos: "Blokkert i Cosmos",
        duplicated: "Duplisert",
        delete: "Slett",
        change: "Endre",
        parentLicenseNumber: "Foreldre lisensnr.",
        product: "Produkt",
        nextInvoice: "Neste fakturadato",
        courseName: "Kursnavn",
        selectProducts: "Velg produkter",
        evaluation: "Evaluering",
        noEvaluation: "Ingen evaluering",
        addNewEvaluationForm: "Legg til nytt evalueringsskjema",
        doNotPublish: "Ikke publiser",
        description: "Beskrivelse",
        selectPrice: "Velg pris",
        address: "Adresse",
        firstName: "Fornavn",
        lastName: "Etternavn",
        activated: "Aktivert",
        createdBy: "Opprettet av",
        back: "Tilbake",
        next: "Neste",
        quantity: "Antall",
        price: "Pris",
        executionDate: "Utførelsesdato",
        account: "Konto",
        copies: "Kopier",
        newCourse: "Nytt kurs",
        duration: "Varighet",
        copy: "kopi",
        addCourse: "Legg til kurs",
        areYouSureYouWantToDeleteCourse: "Er du sikker på at du vil slette kurset?",
        updateCourse: "Oppdater kurs",
        changeCourse: "Endre kurs",
        conflicts: "Konflikter",
        cancelled: "Avlyst",
        trainingRoom: "Kursrom",
        place: "Sted",
        adskCourseId: "ADSK kurs-ID",
        instructor: "Instruktør",
        assistantInstructor: "Hjelpeinstruktør",
        linkToCourse: "Lenke til kurs",
        maxNumberOfSeats: "Maks antall seter",
        postCode: "Postnr.",
        selectComputerEquipment: "Velg datautstyr",
        courseWithTotalPrice: "Kurs med totalpris",
        priceInformation: "Prisinformasjon",
        additionalInformationForParticipantUponConfirmationOfRegistration: "Tilleggsinformasjon til deltaker ved bekreftelse av påmelding",
        courseList: "Kursliste",
        save: "Lagre",
        complete: "Fullfør",
        code: "Kode",
        confirmationCourseRegistration: "Bekreftelse av kurspåmelding",
        reset: " Tilbakestill",
        cancelingCourse: "Avmelding av kurs",
        movingCourses: "Flytting av kurs",
        updatedText: "Oppdarte teksten.",
        couldNotUpdateText: "Kunne ikke oppdatere teksten.",
        contactPersonForInvoice: "Kontaktperson for faktura",
        mobileNo: "Mobilnr.",
        invoiceEmail: "Faktura epost",
        orderReference: "PO nr./fakturareferanse",
        employeeNumber: "Ansattnr.",
        otherComments: "Øvrige kommentarer",
        move: "Flytt",
        reactivate: "Reaktiver",
        lastChanged: "Sist endret",
        courseParticipant: "Kursdeltaker",
        from: "Fra",
        to: "Til",
        level: "Nivå",
        comments: "Kommentarer",
        newCategory: "Ny kategori",
        category: "Kategori",
        selectFromSuperOffice: "Velg fra SuperOffice",
        newDuration: "Ny varighet",
        addedInstructorToList: "La til instruktør i listen.",
        newInstructor: "Ny instruktør",
        adskInstructorId: "ADSK instruktør ID",
        city: "Poststed",
        newLevel: "Nytt nivå",
        addedLocationToList: "La til sted i listen.",
        newPlace: "Nytt sted",
        show: "Vis",
        newPrice: "Ny pris",
        computerEquipment: "Datautstyr",
        prices: "Priser",
        pictures: "Bilder",
        course: "Kurs",
        numberOfDays: "Antall dager",
        emails: "Eposter",
        newEmail: "Ny epost",
        emailSubject: "Epost emne",
        currency: "Valuta",
        userSupport: "Brukerstøtte",
        academic: "Akademisk",
        customerNumber: "Kundenummer",
        contractManager: "Kontraktansvarlig",
        retrievingData: "Henter data",
        addCompanyDepartment: "Legg til firma / avdeling",
        changesFocusAccount: "Endrer Focuskonto.",
        couldNotChangeFocusAccount: "Kunne ikke endre Focuskonto.",
        importTicket: "Importer sak",
        getTicket: "Hent sak",
        title: "Tittel",
        changeUsers: "Endre brukere",
        employee: "Ansatt",
        module: "Modul",
        item: "Vare",
        changes: "Endringer",
        expired: "Utløpt",
        activeOnly: "Kun aktive",
        active: "Aktiv",
        licenses: "Lisenser",
        invoiceCost: "Fakturabeløp",
        newContract: "Ny kontrakt",
        orderOverview: "Ordreoversikt",
        moveContracts: "Flytt kontrakter",
        mergeContracts: "Slå sammen kontrakter",
        showForGroup: "Vis for konsern",
        domainAccess: "Domenetilgang",
        access: "Tilgang",
        licensingCoordinator: "Lisenskoordinator",
        assignLicenseRights: "Tildel lisensrettigheter",
        assignDemoLicenseRights: "Tildel demolisensrettigheter",
        giveEveryoneLicenseAccess: "Gi alle lisenstilgang",
        makeEveryoneACoordinator: "Gjør alle til koordinator",
        removeAllLicenseAccess: "Fjern alle lisenstilganger",
        removeAllCoordinators: "Fjern alle koordinatorer",
        action: "Handling",
        sendEmail: "Send epost",
        customerDetails: "Kundedetaljer",
        contract: "Kontrakt",
        terminated: "Avsluttet",
        focusAccount: "Focuskonto",
        student: "Student",
        credit: "Krediter",
        amount: "Beløp",
        createsCustomer: "Oppretter kunde",
        role: "Rolle",
        accesses: "Tilganger",
        coordinator: "Koordinator",
        created: "Opprettet",
        productList: "Produktliste",
        modules: "Moduler",
        offline: "Offline",
        variant: "Variant",
        version: "Version",
        numberOfSeats: "Ant. seter",
        loan: "Lån",
        automaticLicenseApproval: "Automatisk lisensgodkjenning",
        copyLicenseRights: "Kopier lisensrettigheter",
        externalLicenseRights: "Eksterne lisensrettigheter",
        username: "Brukernavn",
        external: "Ekstern",
        license: "Lisens",
        person: "Person",
        loanId: "Låne ID",
        returned: "Returnert",
        borrowed: "Lånt",
        newLicensingSystem: "Nytt lisenssystem",
        user: "Bruker",
        domain: "Domene",
        machine: "Maskin",
        changeEmail: "Endre epost",
        blocked: "Blokkert",
        retired: "Sluttet",
        changesLicenseAccesses: "Endrer lisenstilganger.",
        language: "Språk",
        selectAdministrator: "Velg administrator",
        components: "Komponenter",
        add: "Legg til",
        selectTriggerType: "Velg trigger type",
        days: "dager",
        triggerDescription: "Trigger beskrivelse",
        variables: "variabler",
        changeLicense: "Endre lisens",
        recurringDiscountPercent: "Gjentagende rabatt (%)",
        renewalPrice: "Fornyelsespris",
        productCode: "Produktkode",
        timestamp: "Tidspunkt",
        errorType: "Feiltype",
        function: "Funksjon",
        backupRetrieved: "Backup hentet",
        noBackupFound: "Fant ingen backup",
        shortDescription: "Kort beskrivelse",
        saveAsBackup: "Lagre som backup",
        sendingYouTo: "Sender deg til",
        working: "Jobber",
        activeUsers: "Aktive brukere",
        freeUpLoans: "Frigjør lån",
        licenseModel: "Lisensmodell",
        expiryDate: "Utløpsdato",
        loanStart: "Lån start",
        accountID: "Konto ID",
        department: "Avdeling",
        companyID: "Firma ID",
        number: "Nummer",
        school: "Skole",
        processes: "Prosesser",
        mainProduct: "Hovedprodukt",
        mainLicenseNo: "Hovedlisensnr.",
        productVersion: "Produktversjon",
        fileVersion: "Filversjon",
        seat: "Sete",
        maxSeat: "Maks sete",
        fileName: "Filnavn",
        sessionID: "Økt ID",
        started: "Startet",
        stopped: "Stoppet",
        loanID: "Låne ID",
        expires: "Utløper",
        lastRenewed: "Sist fornyet",
        returnType: "Returtype",
        releasedBy: "Frigjort av",
        volumeID: "Volum ID",
        operatingSystem: "Operativsystem",
        macAddresses: "MAC-adresser",
        virtualMachine: "Virtuell maskin",
        personID: "Person ID",
        expiredLicenses: "Utløpte lisenser",
        loginFailed: "Mislykket pålogging",
        licenseExploitation: "Lisensutnyttelse",
        logons: "Pålogginger",
        hoursLoggedOn: "Timer pålogget",
        hoursPerSeat: "Timer/Sete",
        offlineLicenses: "Offline lisenser",
        personActivity: "Personaktivitet",
        rejectedLogin: "Avvist pålogging",
        products: "Produkter",
        myPageStatus: "Min Side status",
        period: "Periode",
        terminatedItems: "Avsluttede varer",
        newItems: "Nye varer",
        changedItems: "Endrede varer",
        activeItems: "Aktive varer",
        errorItems: "Feil ved varer",
        licenseName: "Lisensnavn",
        addProductGroup: "Legg til produktgruppe",
        groupName: "Gruppenavn",
        newVersion: "Ny versjon",
        addProduct: "Legg til produkt",
        recurringPrice: "Gjentagende pris",
        seatsPerQuantity: "Seter pr. lisens",
        cloudLicensing: "Skylisensiering",
        canSell: "Kan selge",
        additionalProduct: "Tilleggsvare",
        areYouSureYouWantToDelete: "Er du sikker på at du vil slette?",
        productCategory: "Produktkategori",
        deleteProduct: "Slett produkt",
        deleteVersion: "Slett versjon",
        changeProduct: "Endre produkt",
        systemRelatedProducts: "Systemrelaterte produkter",
        changeVersion: "Endre versjon",
        nimbusCode: "Nimbus kode",
        uploadExcelFile: "Last opp Excel-fil",
        submodules: "Undermoduler",
        selectProduct: "Velg produkt",
        setAsHandled: "Sett som håndtert",
        overview: "Oversikt",
        companyChurn: "Firma churn",
        companyGrowth: "Firma vekst",
        create: "Opprett",
        report: "Rapport",
        seller: "Selger",
        invoiceDate: "Fakturadato",
        productGroup: "Produktgruppe",
        renewals: "Fornyelser",
        costPrice: "Kostpris",
        netGain: "DB",
        sales: "Salg",
        notReleased: "Ikke frigjort",
        noAccountSelected: "Ingen konto valgt",
        licenseAccess: "Lisenstilganger",
        extendTrial: "Forleng prøveperiode",
        stopTrial: "Stopp prøveperiode",
        usedHours: "Timer i bruk",
        thereAreNoLicensesToDisplayHere: "Det er ingen lisenser å vise her.",
        details: "Detaljer",
        hiddenChanges: "Skjulte endringer",
        newLicense: "Ny lisens",
        viewExpiredLicenses: "Vis utløpte lisenser",
        maintenance: "Vedlikehold",
        unitCost: "Enhetspris",
        totalPrice: "Totalpris",
        paymentOverview: "Betalingsoversikt",
        renewalDate: "Fornyelsesdato",
        moveInvoiceDate: "Flytt fakturadato",
        totalBeforeDiscount: "Sum før rabatt",
        totalInvoiceAmount: "Total fakturabeløp",
        goToApproval: "Gå til godkjenning",
        start: "Start",
        contractInformation: "Kontraktinformasjon",
        sellerInSuperOffice: "Selger i SuperOffice",
        overrideSeller: "Overstyr selger",
        useSellerInSuperOffice: "Bruk selger i SuperOffice",
        missingAccount: "Mangler konto",
        hide: "Skjul",
        comment: "Kommentar",
        sum: "Sum",
        invoiceInformation: "Fakturainformasjon",
        missingInSuperOffice: "Mangler i SuperOffice",
        customersOrderNumber: "Kundens ordrenummer",
        invoiceResponsible: "Fakturaansvarlig",
        updateContract: "Oppdater kontrakt",
        trialLicenses: "Prøvelisenser",
        nonAcademic: "Kommersielle",
        unpackSeats: "Pakk ut seter",
        includeRestructuring: "Inkluder omstrukturering",
        new: "Ny",
        activatedOnMyPage: "Aktivert på MinSide",
        accounts: "Kontoer",
        admin: "Admin.",
        allCompanies: "Alle firmaer",
        newCompanies: "Nye firmaer",
        productID: "Produkt ID",
        numberOfUsers: "Antall brukere",
        companyGroupID: "Konsern ID",
        monthlyValueOfLicenses: "Månedlig verdi av lisenser",
        yearlyValueOfLicenses: "Årlig verdi av lisenser",
        status: "Status",
        reports: "Rapporter",
        invoiceAmount: "Fakturabeløp",
        added: "Lagt til",
        licenseType: "Lisenstype",
        showM2S: "Vis M2S",
        createNewPeopleInSuperOffice: "Opprett nye personer i SuperOffice",
        answer: "Svar",
        waitingForResponse: "Venter på svar",
        approvedOffers: "Godkjente tilbud",
        expiredOffers: "Utløpte tilbud",
        offer: "Tilbud",
        newOffer: "Nytt tilbud",
        sent: "Sendt",
        deadline: "Frist",
        lastContact: "Siste kontakt",
        state: "Status",
        offerNo: "Tilbudsnr.",
        createNewOffer: "Opprett nytt tilbud",
        deleteOffer: "Slett tilbud",
        salesAmount: "Salgsum",
        dateOfMove: "Flyttedato",
        none: "Ingen",
        noPriceInformation: "Ingen prisinformasjon",
        noTimeSpent: "Ingen tid brukt",
        domainsThatAutomaticallyApproveAccounts: "Domener som automatisk godkjenner kontoer",
        setDiscountOnAll: "Sett rabatt på alle",
        internalNote: "Intern notat",
        validUntil: "Gyldig til",
        ourProposal: "Vårt forslag",
        customer: "Kunde",
        recipientOfOffer: "Mottaker av tilbud",
        noteToCustomer: "Notat til kunde",
        customerProposal: "Kundens forslag",
        close: "Lukk",
        licenseNr: "Lisensnr.",
        customerNo: "Kundenr.",
        reasonForSale: "Salgsgrunn",
        addDescription: "Legg til beskrivelse",
        twoFactorEnabled: "To-faktor aktivert", 
        pleaseEnterValidEmailAddress: "Vennligst skriv inn en gyldig epostadresse",
        lastNameRequired: "Etternavn er påkrevd",
        firstNameRequired: "Fornavn er påkrevd",
        createFocusAccount: "Opprett Focuskonto",
    },
    simpleTable: {
        searchInTable: "Søk i tabell",
        last24Hours: "Siste 24 timer",
        nextYear: "Neste år",
        nextMonth: "Neste måned",
        nextWeek: "Neste uke",
        today: "I dag",
        lastWeek: "Siste uke",
        lastMonth: "Siste måned",
        lastYear: "Siste år",
        custom: "Egendefinert",
        selectAll: "Velg alle",
        selectAllPossible: `Velg alle mulige {{maxCount}})`,
        copy: "Kopier",
        export: "Eksporter",
        date: "Dato",
        from: "Fra",
        to: "Til",
        show: "Vis",
        search: "Søk",
        showQuantity: "Vis antall",
        total: "Total",
        saveTableConfiguration: "Lagre tabellkonfigurasjon",
        resetTableConfiguration: "Tilbakestill tabellkonfigurasjon",
        seller: "Selger",
    },
    reasonsForSale: {
        Other: "Annet",
        Restructuring: "Regnes ikke i churn",
        Bankruptcy: "Konkurs",
        Retired: "Pensjonert",
        NoNeedForProduct: "Ikke behov for produkt",
        ChangedToCompetitor: "Har kjøpt konkurrerende produkt",
        SaveMoney: "Stoppet for å spare penger"
    },
    froala: {
        addTextOrImages: "Legg til tekst eller bilder her"
    },
    contract: {
        change: "Endring",
    },
    shop: {
        webshop: "Nettbutikk",
        offer: "Tilbud",
        selectProduct: "Velg programvare",
        selectQuantity: "Velg antall",
        register: "Kasse",
        confirmation: "Bekreftelse",
        currentContract: "Gjeldende kontrakt",
        contractNumber: "Kontraktnr.",
        contractDetails: "Kontraktdetaljer",
        currentSeats: "Nåværende seter",
        productName: "Varenavn",
        renewalDate: "Fornyelsesdato",
        action: "Handling",
        add: "Legg til",
        searchInProducts: "Søk i produkter",
        perYear: "pr. år",
        productPage: "Produktside",
        addNewOrExisting: "Legg til produkt seter eller lisenser",
        moduleNames: "Delprodukter",
        requires: "Krever",
        addSeats: "Legg til seter",
        addLicense: "Legg til lisens",
        newLicense: "Ny lisens",
        addNewLicense: "Legg til ny lisens",
        newContract: "Ny kontrakt",
        addNewContract: "Legg til ny kontrakt",
        licenseNumber: "Lisensnr.",
        cart: "Kasse",
        freeSeatAlteration: "Fri seteendring",
        duration: "Varighet",
        months: "måneder",
        type: "Type",
        sumSubscription: "Fornyelsespris",
        //sumSubscription: "Sum abonnement",
        //sumUntilRenewal: "Sum til fornyelse",
        sumUntilRenewal: "Faktureres nå",
        pricePerSeat: "Standard pris",
        buyMoreMsg: "Handler du flere produkter blir de lagt til denne kontrakten. Fullfør kjøp eller avbryt for å velge en annen kontrakt.",
        //priceNowMsg: "Totalpris til fornyelse",
        priceNowMsg: "Faktureres nå",
        recurringTotalPrice: "Fornyelses totalpris",
        //recurringTotalPrice: "Gjentakende totalpris",
        sumInvoiced: "Sum som faktureres",
        invoiceInterval: "Kontraktvarighet (mnd)",
        invoiceIntervalInfoText: "Kan bare legge til produkter på kontrakter med kontraktvarighet på 12 måneder",
        priceNow: "Faktureres nå",
        orderNum: "Ordrenr.",
        yourOrderNumTooltip: "Bruk ordrenr. for å sende faktura til avtalte personer i bedriften.",
        buyMore: "Handle mer",
        goToConfirmation: "Gå til godkjenning",
        acceptCounterProposal: "Godta mottilbud",
        createProposal: "Lag tilbud",
        saveOffer: "Lagre tilbud",
        subscriptionPrice: "Abon. Pris",
        iAcceptAll: "Jeg godtar alle",
        terms: "vilkår",
        orderCompleted: "Ordre fullført",
        thankYouForPurchase: "Takk for din bestilling",
        orderCompleted2: "Bestillingsnr. {{orderId}} er fullført og blir tilgjengelig for bruk umiddelbart. Husk å fordele lisenstilganger til brukerne.",
        productOverview: "Produktoversikt",
        noItemsInCart: "Det er ingen varer i handlekurven",
        addProductFirst: "Legg til et produkt først",
        backToWebshop: "Tilbake til nettbutikk",
        contractResponsible: "Kontraktansvarlig",
        newLicenseMsg: "Her oppretter du en ny kontrakt med en ny lisens. Oppstart fra dagens dato.",
        addSeatsMsg: "Her kan du legge til seter på eksisterende lisenser.",
        addLicenseMsg: "Her kan du legge til nye lisenser på eksisterende kontrakter, som ikke inneholder dette programmet fra før.",
        numberOfProducts: "Antall produkter",
        confirmOfferTitle: "Bekreft tilbud",
        confirmOfferText: "Er du sikker på at du vil sende tilbudet?",
        confirmOfferTextDraft: "Dette vil sende tilbudet til kunden",
        confirmOfferTextPending: "Dette vil overskrive det eksisterende tilbudet til kunden",
        confirmOfferTextCounterProposal: "Dette vil fjerne kundens forslag og overskrive det eksisterende tilbudet til kunden",
        confirmOfferTextAccepted: "Tilbudet er allerede akseptert av kunden. Dette vil gjenåpne tilbudet.",
        confirmOfferTextRejected: "Tilbudet er allerede avslått av kunden. Dette vil gjenåpne tilbudet.",
        confirmOfferTextExpired: "Tilbudet er utgått. Dette vil gjenåpne tilbudet.",
        offerHasErrorText: "De gjentakende rabattene inneholder potensielle feil. Kun admin kan sende tilbudet i nåværende tilstand.",
        offerHasErrorText2: "Autodesk produkter skal ha gjentakende rabatt =25% kun for autodesk kunder. Ellers skal alle produkter ha gjentakende rabatt =0%.",
        sendOffer: "Send tilbud",
        ourProposal: "Vårt forslag",
        customerProposal: "Kundens forslag",
        cartOverview: "Handlekurv oversikt",
        offerSaved: "Tilbud lagret",
        sendingOffer: "Sender tilbud",
        acceptingCounterProposal: "Godtar mottilbud",
        proposalDeleted: "Tilbud slettet",
        offerSent: "Tilbud sendt",
        offerAccepted: "Tilbud akseptert",
        noProposalRecepientsError: "Ingen mottakere for tilbudet, velg minst en mottaker",
        noProductsError: "Ingen produkter i handlekurven",
        oneTimeDiscountTotal: "Engangsrabatt totalt",
        recurringDiscountTotal: "Fornyelsesrabatt totalt",
        //recurringDiscountTotal: "Gjentakende rabatt totalt",
    },
    licenseType: {
        slm: "Enbruker",
        nlm: "Flerbruker",
        namedUser: "Navngitt bruker",
        named_user: "Navngitt bruker",
        oneTime: "Engangsvare",
        unknown: "Ukjent"
    },
    proposalState: {
        Accepted: "Godkjent",
        Pending: "Venter på kunde",
        Draft: "Utkast",
        CounterProposal: "Mottilbud (Venter på selger)",
        Rejected: "Avslått",
        Expired: "Utløpt",
        Active: "Aktiv",
    },
}